import React, { Component } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import PopupDep from './popupdeposit';
import Fishing from "./fising";
import Sport from "./sport";
import Lotto from "./lotto";
import Listgameall from "./linklistall";
import { isMobile } from 'react-device-detect';
import GameHit from "./gamehit";
import moment from 'moment';
import Luckyfortune from "./luckyfortune";
import Checkindaily from "./checkin";
import Cardminigame from "./cardminigame";
import md5 from 'md5';
import Register from './register';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Sidebar from './sidebar';
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NProgress from "nprogress";
import Login from './signin';
import Banner from "./banner";
var settings = {
    dots: true,
    infinite: true,
    slidesToShow: (window.innerWidth <= 760) ? 1 : 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"
};
class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            trueaccount: null,
            products_page_count: 1,
            paymentbool: false,
            isActive: false,
            activeTab: 1,
            resetpass: 0,
            paymentlist: null,
            checkcredit: false,
            refer: 1,
            tblpaymentgateway: "",
            showmodal: false,
            historylist: [],
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            afficiate: [],
            modalx: false,
            cashoutSet: [],
            modal: false,
            linkaff: "",
            point: 0,
            depositamount: 0,
            maxwithdrawstatus: 0,
            useradvice: [],
            afficiatetoday: [],
            afficiateall: [],
            balance: 0,
            counter: 300,
            counterx: false,
            qrcode: null,
            qrcodecheck: false,
            loginstate: null,
            firstname: null,
            lastname: null,
            activeTab: 1,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            prolistx: [],
            prodetail: [],
            username: "",
            tabselect: null,
            showpassnew: false,
            showpasscf: false,
            showpassold: false,
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            limit: null,
            name: "",
            password: "",
            oldpassword: "",
            passwordcf: "",
            left: false,
            pathname: "",
            linelink: ""
        }
    }
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            console.log("promotionlist", res.data.message)
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            //   console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.setState({
            checkcredit: true,
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            // console.log(2);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                        checkcredit: false,
                    });
                }
                else if (res.data.status === 401) {
                    //   console.log(res.data);
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            ////////console.log(ex);
        }
    }
    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    onChangexxxxx = (checked) => {
        console.log(128, checked)
        if (checked == 1) {
            if (this.state.showpassold) {
                this.setState({ showpassold: false });
            }
            else {
                this.setState({ showpassold: true });
            }
        }
        else if (checked == 2) {
            if (this.state.showpassnew) {
                this.setState({ showpassnew: false });
            }
            else {
                this.setState({ showpassnew: true });
            }
        }
        else if (checked == 3) {
            if (this.state.showpasscf) {
                this.setState({ showpasscf: false });
            }
            else {
                this.setState({ showpasscf: true });
            }
        }
    }

    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };

    checkurl = (e, url) => {
        window.history.pushState(null, null, url);
        const pathname = window.location.pathname.split("/")
        console.log(210, pathname);
        if (pathname.length > 1) {
            if (pathname[1] == "") {
                console.log(250, pathname[1]);
                this.setState({
                    tabselect: 0,
                });
            }
            else if (pathname[1] == "casino") {
                console.log(250, pathname[1]);
                this.setState({
                    tabselect: 10,
                });
            }
            else if (pathname[1] == "gamehit") {
                this.setState({
                    tabselect: 11,
                });
            }
            else if (pathname[1] == "fishing") {
                this.setState({
                    tabselect: 12,
                });
            }
            else if (pathname[1] == "luckyfortune") {
                this.setState({
                    tabselect: 35,
                });
            }
            else if (pathname[1] == "checkindaily") {
                this.setState({
                    tabselect: 36,
                });
            }
            else if (pathname[1] == "cardminigame") {
                this.setState({
                    tabselect: 37,
                });
            }
            else if (pathname[1] == "slot") {
                console.log(101, pathname);
                this.setState({
                    tabselect: 13,
                });
            }
            else if (pathname[1] == "sport") {
                this.setState({
                    tabselect: 14,
                });
            }
            else if (pathname[1] == "event") {
                this.setState({
                    tabselect: 16,
                });
            }
            else if (pathname[1] == "lotto") {
                this.setState({
                    tabselect: 17,
                });
            }
            else if (pathname[1] == "withdraw") {
                if (this.state.loginstate) {
                    this.setState({
                        tabselect: 2,
                    });
                }
                else {
                    window.history.pushState(null, null, "/");
                    this.setState({
                        tabselect: 0,
                    });
                }
            }
            else if (pathname[1] == "deposit") {
                if (this.state.loginstate) {
                    this.setState({
                        tabselect: 1,
                    });
                }
                else {
                    window.history.pushState(null, null, "/");
                    this.setState({
                        tabselect: 0,
                    });
                }
            }
            else if (pathname[1] == "signin") {
                this.setState({
                    tabselect: 23,
                });
            }
            else if (pathname[1] == "register") {
                this.setState({
                    tabselect: 22,
                });
            }
            else if (pathname[1] == "statement") {
                this.setState({
                    tabselect: 3,
                });
            }
            else if (pathname[1] == "profile") {
                this.setState({
                    tabselect: 8,
                });
            }
            else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                this.setState({
                    tabselect: 4,
                    refer: 1
                });
            }
            else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                this.setState({
                    tabselect: 4,
                    refer: 2
                });
            }
            else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                this.setState({
                    tabselect: 4,
                    refer: 3
                });
            }
            else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                this.setState({
                    tabselect: 4,
                    refer: 4
                });
            }
            else if (pathname[1] == "rebate") {
                this.setState({
                    tabselect: 5,
                });
            }
            else if (pathname[1] == "promotion") {
                // this.promotionlist();
                this.setState({
                    tabselect: 7,
                });
            }
            else if (pathname[1] == "listgameall") {
                this.setState({
                    tabselect: 15,
                });
            }
        }
        else {
            this.setState({
                tabselect: 0,
            });
        }
    }

    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
      confirmdeposit = async (e, num, paymentstate = 0) => {
        console.log(493, num)
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                if (num === 0) {
                    if (token != null) {
                        Username = decoded.message.playerid;
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            paymentstate: paymentstate,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            var userAgent = navigator.userAgent
                            console.log("tblpaymentgatewayx", res.data.tblpaymentgatewayx)
                            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                window.location.href = res.data.tblpaymentgatewayx.link;
                            }
                            else {
                                if (!isMobile) window.open(res.data.tblpaymentgatewayx.link, '_blank', 'height=1000,width=1000');
                                else window.open(res.data.tblpaymentgatewayx.link);
                            }
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.tblpaymentgatewayx?.QRcode,
                                paymentlist: res.data.tblpaymentgatewayx,
                                tabselectsec: 1,
                                tabselectdeposit: 0,
                                counter: 300,
                                counterx: true,
                                qrcodecheck: true,
                            });
                            await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
                        });
                    }
                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');

            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }

        else if (num === 5) {
            document.getElementById("truemonney").click()
            //deposittruemoneyModal
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    onChange = async (event) => {
        console.log(event);
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            if (nam === "withdrawamount") {
                if (this.state.maxwithdrawstatus === 1) {
                    this.setState({ [nam]: this.state.balance });
                    await this.notify("warning", 'บังคับถอนยอดทั้งหมด');
                }
                else if (Number(val) <= Number(this.state.balance)) {
                    this.setState({ [nam]: val });
                }
                else {
                    await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');

                }
            } else {
                this.setState({ [nam]: val });
            }

        }
    };
    submitwithdraw = async (e) => {
        console.log(this.state.withdrawamount, this.state.balance);
        if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
            if (parseFloat(this.state.withdrawamount) >= 10) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/userwithdraw", {
                        User_id: Username,
                        System: Systems,
                        amount: this.state.withdrawamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        console.log(res.data);
                        if (res.data.status === 200) {
                            await this.notify("success", 'รายการถอนเรียบร้อย');
                            window.location.href = '/statement';
                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", 'ท่านติด Turnover อีก ' + res.data.amountturnover + " บาท");

                        }
                        else if (res.data.status === 207) {
                            await this.notify("error", 'ขั้นต่ำในการถอน ' + res.data.maxwithdraw + " บาท");

                        }
                        else {
                            await this.notify("error", "ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน");
                        }
                    });
                }
                else {
                    await this.notify("error", 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน');
                }
            }
            else {
                await this.notify("warning", 'ขั้นต่ำในการถอน 50 บาท');
            }
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }

    }
    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf } = this.state;
        console.log(type, password, oldpassword, passwordcf);
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }
    }
    async opencliaminvite(evt, cityName) {
        console.log(cityName);
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliaminvite", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    handleClick = async (e, price) => {
        console.log(price);
        if (price <= this.state.balance) {
            this.setState({
                withdrawamount: price
            });
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }
    }
    handleClickreposit = async (e, price) => {
        this.setState({
            depositamount: price
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    this.setState({
                        showmodal: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 204) {
                    await this.notify("error", 'ท่านใช้สิทธวันนี้ครบแล้ว');
                    e.preventDefault();
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว');
                    e.preventDefault();
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
    }
    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await this.notify("success", 'ดำเนินการใช้คูปองเรียบร้อย');
                }
                else {
                    await this.notify("warning", 'ไม่มี Key นี้ในระบบ');
                }
            });
        }
        else {
            await this.notify("warning", 'คุณไม่ได้ล๊อคอิน');
        }

    }
    async checklogin() {
        var token = localStorage.getItem('auth_token');
        console.log("localStorage", token);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await this.rechecklogin(Username, token);
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    copy = async (e, accnumber) => {
        toast.success("คัดลอกเรียบร้อย", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        navigator.clipboard.writeText(accnumber)
    }
    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };
    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    fetchCacheVersion = async (System) => {
        try {
            const response = await instance.get('/api/v1/cacheversion', {
                params: {
                    System: Systems
                }
            });
            console.log("📥 Fetched cache version:", response.data);
            return response.data.message.versionCaching;
        } catch (error) {
            console.error("❌ Failed to fetch cache version:", error);
            return null;
        }
    };
    async _fetchAndUpdateTheme(Systems, cacheKey) {
        try {
            const res = await instance.post("/api/v1/getthemesv", { System: Systems });
            if (res.data.status === 200) {
                const theme = res.data.ThmeseV;
                const current = (this.state && this.state.ThmeseV) || document.body.getAttribute("data-theme");
                if (theme && theme !== current) {
                    // update UI + state + cache
                    document.body.setAttribute("data-theme", theme);
                    this.setState({ ThmeseV: theme });
                    if (this.setCache) this.setCache(cacheKey, theme);
                } else {
                    // ถ้าเหมือนกัน อัปเดต cache timestamp เท่านั้น (เพื่อรีเซ็ต TTL)
                    if (this.setCache) this.setCache(cacheKey, theme);
                }
            }
        } catch (err) {
            throw err;
        }
    }
    async callgetthemesv(Systems) {
        const cacheKey = "theme_v1";            // ปรับชื่อ key ตามต้องการ
        const ttl = 24 * 60 * 60 * 1000;        // 24 ชั่วโมง (ปรับถ้าต้องการ 1 ชั่วโมง = 3600000)

        // 1) ถ้ามี cache ที่ยัง valid ให้ใช้ทันที (fast)
        const cached = this.getCache ? this.getCache(cacheKey, ttl) : null;
        if (cached) {
            // Apply cached theme right away
            document.body.setAttribute("data-theme", cached);
            this.setState({ ThmeseV: cached });
            // แต่ยังทำ background fetch เพื่อตรวจสอบ/รีเฟรช (stale-while-revalidate)
            this._fetchAndUpdateTheme(Systems, cacheKey).catch(err => console.error("theme background fetch:", err));
            return;
        }

        // 2) ถ้าไม่มี cache ให้รอ fetch ปกติ (first load)
        try {
            const res = await instance.post("/api/v1/getthemesv", { System: Systems });
            if (res.data.status === 200) {
                const theme = res.data.ThmeseV;
                document.body.setAttribute("data-theme", theme);
                this.setState({ ThmeseV: theme });
                // save cache
                if (this.setCache) this.setCache(cacheKey, theme);
            }
        } catch (err) {
            console.error("callgetthemesv error:", err);
            // ถ้า fetch ล้มเหลว ไม่ต้องทำอะไรเพิ่มเติม (ถ้ามี cached value จะใช้ของเก่า)
        }
    }
    // ฟังก์ชันยิง API เวลา click ผ่าน aff link
    // API call for affiliate click
    // เหมือนเดิม: ยิง API เวลาเป็น aff link
    async saveclickaff(linkid) {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems,
            });

            if (res.data.status === 200) {
                console.log("saveclickaff response", res.data);
                const date = new Date();
                const username = res.data.username;

                this.setState({
                    userrecomend: username,
                    link: linkid,
                });

                const object = { date, username };
                localStorage.setItem("aff", JSON.stringify(object));
            }
        } catch (err) {
            // console.error("saveclickaff error", err);
        }
    }

    // เหมือนเดิม: ยิง API เวลาเป็น reg link
    async saveclick(linkid) {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems,
            });

            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;

                this.setState({
                    userrecomend: username,
                });

                const object = { date, username };
                localStorage.setItem("aff", JSON.stringify(object));
            }
        } catch (err) {
            // console.error("saveclick error", err);
        }
    }

    // helper เช็คว่า cache หมดอายุหรือยัง (เช่น 7 วัน)
    // helper for cache expiry
    isAffiliateCacheValid(dateStr) {
        if (!dateStr) return false;
        const saved = new Date(dateStr);
        if (isNaN(saved.getTime())) return false;

        const diffMs = Date.now() - saved.getTime();
        const MAX_DAYS = 7;
        const maxMs = MAX_DAYS * 24 * 60 * 60 * 1000;

        return diffMs <= maxMs;
    }

    // ===========================
    // init ตอนเข้าเพจ
    // ===========================
    async initAffiliate() {
        const url = new URL(window.location.href);
        const affParam = url.searchParams.get("aff");
        const regParam = url.searchParams.get("reg");

        // 1) เช็ค cache ก่อนเสมอ
        const tokenf = localStorage.getItem("aff");
        if (tokenf) {
            try {
                const codev = JSON.parse(tokenf);
                const Username = codev.username;
                const dateStr = codev.date;

                if (Username && this.isAffiliateCacheValid(dateStr)) {
                    this.setState({ userrecomend: Username });
                }
            } catch (e) { }
        }

        const tokenx = localStorage.getItem("register");
        if (!this.state.userrecomend && tokenx) {
            try {
                const codev = JSON.parse(tokenx);
                const Username = codev.username;
                if (Username) {
                    this.setState({ userrecomend: Username });
                }
            } catch (e) { }
        }

        // 2) จากนั้นถ้ามี aff/reg ใน URL → ยิง API ทับค่า cache
        if (affParam) {
            const affCode = affParam;
            await this.saveclickaff(affCode);
            return;
        }

        if (regParam) {
            const regCode = regParam;
            await this.saveclick(regCode);
            this.setState({ userrecomend: regCode });
            return;
        }
    }


    async componentDidMount() {

        console.log("Component did mount");
        await this.initAffiliate();
        const { counterx } = this.state
        this.checkurl(null, window.location.pathname);
        this.promotionlist();
        if (counterx) {
            setInterval(() =>
                this.setState({
                    counter: this.state.counter - 1
                })
                , 1000);
        }
        try {
            this.checklogin();
            this.callgetthemesv(Systems);
            // const cacheVersionKey = "cacheVersion";
            const latestCacheVersion = await this.fetchCacheVersion();
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 5 * 60 * 1000; // 30 นาที
            var token = localStorage.getItem('auth_token');
            var Playerid = null
            if (token != null) {
                var decoded = jwt_decode(token);
                Playerid = decoded.message.playerid;
            }
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);
            // const currentCacheVersion = localStorage.getItem(cacheVersionKey);
            if (mainSettingCache && mainSettingCache.version === latestCacheVersion) {

                console.log("Using cached data for main setting", mainSettingCache);
                const data = mainSettingCache.data;

                document.title = data.tblsetting[0].title;
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link);


                const linkx = document.querySelector("link[rel*='icon']") || document.createElement('link');
                linkx.rel = 'icon';
                linkx.type = 'image/png';
                linkx.sizes = '32x32';
                linkx.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(linkx);

                try {


                    this.setState({
                        webname: data.tblsetting[0].Description,
                        logoimg: data.tblsetting[0].imglogo,
                        whellsetting: data.tblwheelsetting,
                        maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
                        luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                        linelink: data.message[1].value,
                        paymentbool: data.paymentbool,
                        webnamex: data.message[7].value,
                        mainacc: data?.tblmain,
                        limitwithdraw: { minw: data.tblsetting[0].minwithdraw, maxw: data.tblsetting[0].maxwithdraw },
                        describemain: data.tblsetting[0].title,
                        System: data.tblcatagoryx[0].System,
                        cashoutSet: data.tblcashoutsetting[0],
                        inviteSet: data.tblinvitedsetting[0],
                        datas: data.message,
                        limit: { min: data.tblcatagoryx[0].limitdeposit, max: data.tblcatagoryx[0].maxdeposit },
                    });
                }
                catch (ex) {
                    console.log(ex)
                    await instance.post("/api/v1/mainsetting", {
                        System: Systems,
                        Playerid: Playerid,
                    }).then((res) => {
                        if (res.data.status === 200) {
                            console.log("luckywheeldisplay", res.data);
                            const datas = res.data.message;
                            const min = res.data.tblcatagoryx[0].limitdeposit;
                            const max = res.data.tblcatagoryx[0].maxdeposit;
                            const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                            const limit = { min, max };
                            const minw = res.data.tblsetting[0]?.minwithdraw;
                            const maxw = res.data.tblsetting[0]?.maxwithdraw;
                            const limitwithdraw = { minw, maxw };
                            const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;
                            document.title = res.data.tblsetting[0].title;
                            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                            link.type = 'image/svg+xml';
                            link.rel = 'icon';
                            link.href = res.data.tblsetting[0].imglogo;
                            document.getElementsByTagName('head')[0].appendChild(link);
                            this.setState({
                                webname: res.data.tblsetting[0].Description,
                                logoimg: res.data.tblsetting[0].imglogo,
                                whellsetting: res.data.tblwheelsetting,
                                maxwithdrawstatus: maxwithdrawstatus,
                                luckywheeldisplay: luckywheeldisplay,
                                linelink: datas[1].value,
                                limitwithdraw: limitwithdraw,
                                webnamex: datas[7].value,
                                mainacc: data?.tblmain,
                                paymentbool: res.data.paymentbool,
                                describemain: res.data.tblsetting[0].title,
                                System: res.data.tblcatagoryx[0].System,
                                cashoutSet: res.data.tblcashoutsetting[0],
                                inviteSet: res.data.tblinvitedsetting[0],
                                datas: datas,
                                limit: limit,
                            });

                            this.setCache(mainSettingKey, { version: latestCacheVersion, data: res.data });

                        }
                    });
                }
            } else {
                await instance.post("/api/v1/mainsetting", {
                    System: Systems,
                    Playerid: Playerid,
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("luckywheeldisplay", res.data);
                        const datas = res.data.message;
                        const min = res.data.tblcatagoryx[0].limitdeposit;
                        const max = res.data.tblcatagoryx[0].maxdeposit;
                        const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                        const limit = { min, max };
                        const minw = res.data.tblsetting[0].minwithdraw;
                        const maxw = res.data.tblsetting[0].maxwithdraw;
                        const limitwithdraw = { minw, maxw };
                        const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;

                        document.title = res.data.tblsetting[0].title;
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/svg+xml';
                        link.rel = 'icon';
                        link.href = res.data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(link);
                        this.setState({
                            webname: res.data.tblsetting[0].Description,
                            logoimg: res.data.tblsetting[0].imglogo,
                            whellsetting: res.data.tblwheelsetting,
                            maxwithdrawstatus: maxwithdrawstatus,
                            luckywheeldisplay: luckywheeldisplay,
                            linelink: datas[1].value,
                            limitwithdraw: limitwithdraw,
                            mainacc: res.data.tblmain,
                            webnamex: datas[7].value,
                            describemain: res.data.tblsetting[0].title,
                            System: res.data.tblcatagoryx[0].System,
                            cashoutSet: res.data.tblcashoutsetting[0],
                            inviteSet: res.data.tblinvitedsetting[0],
                            datas: datas,
                            limit: limit,
                        });

                        this.setCache(mainSettingKey, { version: latestCacheVersion, data: res.data });

                    }
                });
            }
            const getTrueKey = `getTrueCache_${Playerid}_${Systems}`;
            const getTrueTTL = 30 * 60 * 1000; // 30 นาที
            const getTrueCache = this.getCache(getTrueKey, getTrueTTL);
            if (getTrueCache) {
                console.log("Using cached data for getTrue");
                this.setState({
                    trueaccount: getTrueCache,
                });
            } else {
                await instance.post("/api/v1/gettrue", {
                    userid: Playerid,
                    System: Systems,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("not Using cached getTrue", res);
                        const trueAccount = res.data.message.tbltruewallet[0];
                        this.setState({
                            trueaccount: trueAccount,
                        });
                        this.setCache(getTrueKey, trueAccount);
                    }
                }).catch((err) => {
                    console.error("Error fetching getTrue data:", err);
                });
            }

        }
        catch (error) {
            //////console.log();
        }

    }


    checktab(e, index) {
        console.log(111255, index == 2 && this.state.qrcode != null);
        this.setState({
            tabselect: index,
            qrcodecheck: false,
            tabselectdeposit: 0,
        });


    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }
    async checkuseradvice() {
        instance.post("/api/v1/checkuseradvice", {
            User_id: this.state.username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log(res.data.message.useradvicelist);
                this.setState({
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            console.log(45555555555555555);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);

                if (res.data.status === 200) {
                    this.calllisthistory(Username);
                    localStorage.setItem('auth_token', res.data.token)
                    console.log(1067, res.data);
                    this.setState({
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        firstname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        afficiatetoday: res.data.userafftoday,
                        afficiateall: res.data.useraffall,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        showmodal: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        showmodal: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                this.notify("success", 'ทำรายการรับเงินเรียบร้อย');

            }
            else if (res.data.status === 201) {
                await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                return false;
            }
            else if (res.data.status === 202) {
                await this.notify("error", 'ไม่สามารถทำรายการได้');
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/';
            }
        });
    }
    navigateTo = async (path, { selection = 1, headerOffset = 64, scrollTimeoutMs = 4000 } = {}) => {
        // start progress + loading
        NProgress.start();
        this.setState({ loading: true });

        console.log("navigateTo:", path, selection);

        // reset UI
        this.prev = document.body.style.backgroundColor;
        document.body.style.backgroundColor = '#EFEFF4';
        this.setState({ modalx: false, modal: false, listitallgame: [] });

        // --- normalize path + split
        const raw = (path || "/").replace(/^#/, "");
        const parts = raw.replace(/^\/+|\/+$/g, "").split("/");
        const seg1 = decodeURIComponent(parts[0] || "");
        const seg2 = decodeURIComponent(parts[1] || "");
        const seg3 = decodeURIComponent(parts[2] || "");

        console.log("navigateTo segs:", { seg1, seg2, seg3 });

        // dynamic listgameall (special-case)
        if (seg1 === "listgameall") {
            if (seg2 && seg3) {
                console.log("navigateTo dynamic →", seg2, seg3);
                try {
                    // await this.getgame(seg2, seg3);
                    this.setState({ tabselect: 15, partner: seg3 });
                    console.warn('[navigateTo] getgame(listgameall)', seg1);
                } catch (e) {
                    console.warn('[navigateTo] getgame(listgameall) failed', e);
                } finally {
                    NProgress.done();
                    window.scrollTo(0, 0);
                    this.setState({ loading: false });
                }
                return;
            } else {
                this.setState({ tabselect: 0 });
                NProgress.done();
                window.scrollTo(0, 0);
                this.setState({ loading: false });
                return;
            }
        }

        // route map
        const key = seg1 === "" ? "" : `${seg1}${seg2 ? "/" + seg2 : ""}`;

        const requireLogin = async (okTab) => {
            if (this.state.loginstate) { this.setState({ tabselect: okTab }); return true; }
            this.setState({ tabselect: 0 });
            return false;
        };

        const routeHandlers = {
            "/": async () => this.setState({ tabselect: 0 }),
            "": async () => this.setState({ tabselect: 0 }),
            "game/casino": async () => { await this.getgame('casino', seg3, "993"); this.setState({ tabselect: 10 }); },
            "game/hit": async () => { await this.getgame('slot', seg3, "992"); await this.getprovidor('slot', seg3, "2255"); this.setState({ tabselect: 11 }); },
            "game/providor": async () => { await this.getgame('casino', seg3, "994"); this.setState({ tabselect: 18 }); },
            "game/fishing": async () => { await this.getgame('fishing', seg3, "995"); this.setState({ tabselect: 12 }); },
            "game/slot": async () => { await this.getgame('slot', seg3, "995"); this.setState({ tabselect: 13 }); },
            "game/export": async () => { await this.getgame('export', seg3, "11131"); this.setState({ tabselect: 51 }); },
            "game/sport": async () => { await this.getgame('sport', seg3, "996"); this.setState({ tabselect: 14 }); },
            "game/list": async () => { await this.getgame('slot', seg3); this.setState({ tabselect: 20, partner: seg3 }); },
            "game/lotto": async () => {
                await this.getgame('lotto', seg3, "lotto");
                this.setState({ tabselect: 17 });
                this.timerx = setInterval(() => { this.setState({ currentTime: new Date().getTime() }); }, 1000);
            },
            "loss": async () => this.setState({ tabselect: 25 }),
            "manager/ranking": async () => this.setState({ tabselect: 27 }),
            "minigame/luckywheel": async () => this.setState({ tabselect: 28 }),
            "event": async () => this.setState({ tabselect: 16 }),
            "manager/withdraw": async () => requireLogin(2),
            "manager/deposit": async () => requireLogin(1),
            "manager/statement": async () => requireLogin(3),
            "userinfo": async () => {
                if (await requireLogin(8)) this.setState({ tabselect: 8, tabselection: selection });
                if (selection == 5) {
                    const token = localStorage.getItem('auth_token');
                    if (token) {
                        try {
                            const decoded = jwt_decode(token);
                            const Username = decoded.message.playerid;
                            await this.calllisthistory(Username);
                        } catch (ex) { console.warn('[navigateTo] calllisthistory failed', ex); }
                    }
                }
            },
            "register": async () => this.setState({ tabselect: 22 }),
            "signin": async () => this.setState({ tabselect: 23 }),
            "refer/overview": async () => this.setState({ tabselect: 4, refer: 1 }),
            "profile": async () => this.setState({ tabselect: 8 }),
            "refer/income-summary": async () => this.setState({ tabselect: 4, refer: 3 }),
            "refer/share-network": async () => this.setState({ tabselect: 4, refer: 4 }),
            "rebate": async () => this.setState({ tabselect: 5 }),
            "manager/promotion": async () => this.setState({ tabselect: 7, tabselection: selection }),
            "manager/diamondclub": async () => {
                this.setState({ tabselect: 99 });
                this.prev = document.body.style.backgroundColor;
                document.body.style.backgroundColor = '#17191c';
            },
        };

        // do the route + scroll, ensure loading/NProgress always cleared
        try {
            if (routeHandlers[key]) {
                await routeHandlers[key]();
            } else {
                this.setState({ tabselect: 0 });
            }

            // allow one RAF tick for setState/dom updates
            await new Promise((resolve) => requestAnimationFrame(() => resolve()));

            // final selection prefer real state.tabselect
            const finalSelection = (this.state && typeof this.state.tabselect !== 'undefined' && this.state.tabselect !== null)
                ? this.state.tabselect
                : selection;

            console.log('[navigateTo] finalSelection ->', finalSelection);

            // perform deterministic scroll if available
            if (typeof this.deterministicScrollToTab === 'function') {
                try {
                    const ok = await this.deterministicScrollToTab(finalSelection, {
                        headerOffset,
                        timeoutMs: scrollTimeoutMs,
                        pollInterval: 60,
                        maxTries: 8
                    });
                    console.log('[navigateTo] deterministicScrollToTab ok ->', ok);
                } catch (err) {
                    console.warn('[navigateTo] deterministicScrollToTab threw', err);
                    // fallback to simple scroll
                    window.scrollTo(0, 0);
                }
            } else {
                window.scrollTo(0, 0);
            }
        } finally {
            // always reset loading and progress
            try { this.setState({ loading: false }); } catch (e) { console.warn('setState loading false failed', e); }
            NProgress.done();
        }
    };
    render() {
        const { prodetail, picnonpro, paymentbool, paymentlist, cashoutSet, trueaccount, loginstate, prolistx, rankob, accnumber, tabselect, tblpaymentgateway, mainacc, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
        var accnumberx;
        console.log("mainacc", mainacc);
        if (accnumber != null && accnumber != undefined) {
            accnumberx = accnumber[0];
        }
        const menuItems = [
            { id: "6", bank: "KBANK", name: "กสิกรไทย KBANK", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fkbank.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-1sno93h" },
            { id: "5", bank: "SCB", name: "ไทยพาณิชย์ SCB", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fscb.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-atderz" },
            { id: "7", bank: "BBL", name: "กรุงเทพ BBL", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fbbl.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-11y6xcv" },
            { id: "14", bank: "KTB", name: "กรุงไทย KTB", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fktb.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-9xnm3b" },
            { id: "8", bank: "BAY", name: "กรุงศรี BAY", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fbay.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-qjyshk" },
            { id: "11", bank: "ttb", name: "ทหารไทยธนชาต ttb", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fttb.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-1xo111q" },
            { id: "15", bank: "GSB", name: "ออมสิน GSB", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fgsb.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-u90vr8" },
            { id: "16", bank: "BAAC", name: "ธ.ก.ส. BAAC", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fbaac.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-1tacmq9" },
            //  { id: "067", name: "ทิสโก้ TISCO", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Ftsco.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-10llw9i" },
            { id: "9", bank: "KK", name: "เกียรตินาคิน KK", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fkk.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-1txbj9z" },
            //  { id: "022", name: "ซีไอเอ็มบี CIMB", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fcimb.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-1uculzh" },
            //  { id: "024", name: "ยูโอบี UOB", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fuob.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-mnuwuu" },
            //  { id: "073", name: "แลนด์ แอนด์ เฮ้าส์ LH", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Flhbank.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-9um8mf" },
            //  { id: "031", name: "เอชเอสบีซี HSBC", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fhsbc.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-b0b9u5" },
            { id: "53", bank: "GHB", name: "อาคารสงเคราะห์ GHB", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Fghba.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-4xpz60" },
            { id: "54", bank: "scb", name: "ธนาคารอิสลามแห่งประเทศไทย", imgSrc: "https://cdn.javisx.com/image/77e99108-dd75-4d15-a8b1-8c11685448f4.PNG", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-4xpz60" },
            //     { id: "070", name: "ไอซีบีซี ICBC", imgSrc: "https://tentugame.com/_next/image?url=https%3A%2F%2Fd12lxcfs2l5om8.cloudfront.net%2Fnew_webimages%2Fbank%2Ficbc.webp&w=64&q=75", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-jdfhpn" },
            { id: "99", bank: "scb", name: "ทรูวอลเลท True", imgSrc: "https://cdn.javisx.com/image/ca805e12-cad1-41b7-84bf-3fb2c637143f.png", classes: "MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters css-jdfhpyy" },
        ];
        return (
            <>

                <div className="-contact-wrapper row m-0 ">
                    <nav id="navbar" className="x-header navbar navbar-expand -logged py-0 back-to-top-btn">

                        <Sidebar
                            loginstate={this.state.loginstate}
                            rankpic={this.state.rankpic}
                            logoimg={this.state.logoimg}
                            onNavigate={(to, e) => {

                                if (e?.preventDefault) e.preventDefault();
                                window.history.pushState(null, "", to);
                                // เรียกฟังก์ชันกลางของคุณ
                                this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                            }} />
                    </nav>
                    <div style={{ display: tabselect == 35 ? "" : "none" }}>
                        {tabselect == 35 && (
                            <Luckyfortune
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                }}
                            />
                        )}
                    </div>
                    <div style={{ display: tabselect == 36 ? "" : "none" }}>
                        {tabselect == 36 && (
                            <Checkindaily
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                }}
                            />
                        )}
                    </div>
                    <div style={{ display: tabselect == 37 ? "" : "none" }}>
                        {tabselect == 37 && (
                            <Cardminigame
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                }}
                            />
                        )}
                    </div>
                    {tabselect != 22 && tabselect != 23 && tabselect != 35 && tabselect != 36 && tabselect != 37 && tabselect != null && (<div className="row m-0" >

                        <div className="col-sm-11 col-md-8 col-lg-6 offset-lg-3 col-md-6 offset-md-2 p-0 bg-header-full">
                            <div className="text-white v5-content">
                                <div className="mt-1 text-white padding-banner animated animatedFadeInUp fadeInUp p-0" style={{ display: this.state.loginstate ? "none" : "" }}>
                                    <div className="m-2 px-0 card-width-banner" style={{ marginBottom: 2 }}>
                                        <section className="carousel" dir="ltr" aria-label="Gallery">
                                            <div className="carousel__viewport">
                                                <Banner />
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <div className="m-0 mt-2 mb-3 animated animatedFadeInUp fadeInUp">
                                    <div className="bg animated animatedFadeInUp fadeInUp">
                                        <div className="d-flex justify-content-start text-white input-group-text bg-marquee-hh align-items-center">
                                            <div>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={16}
                                                    height={16}
                                                    fill="currentColor"
                                                    className="bi bi-megaphone"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49a68.14 68.14 0 0 0-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036 2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A60.49 60.49 0 0 1 4 10.065zm-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68.019 68.019 0 0 0-1.722-.082z" />
                                                </svg>
                                                <b> &nbsp; ประกาศ :</b>
                                            </div>
                                            <div className="w-100">
                                                <div>
                                                    <marquee scrolldelay={100} className="ancm-text-1">
                                                        switchbet เว็บแท้ เว็บตรง ส่งตรงจากต่างประเทศ มาตรฐานระดับสากล มั่นคง ปลอดภัย
                                                    </marquee>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row m-2 bg-container-app bg-logo" style={{ display: this.state.loginstate ? "" : "none" }} >
                                        <div className="col-3 pr-0 pt-2">
                                            <div className="text-white-credit-balance" id="Username">
                                                {username}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div id="walletBG-1" className="mt-sm-3">
                                                <div id="walletBG">
                                                    <div id="walletInner" />
                                                    <div className="wrapper">
                                                        <div className="content text-font-balance">
                                                            <p className="m-0">
                                                                <b>เครดิตคงเหลือ</b>
                                                            </p>
                                                            <h4>
                                                                <b>
                                                                    <span className="mb-balance text-font-balance"><NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /></span>
                                                                    <small>฿</small>
                                                                </b>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <button className="btn-refresh" type="button">
                                                        <a
                                                            onClick={(e) => {
                                                                this.recheccredit(e)
                                                            }}
                                                            role="button text-white-credit-balance" id="icon-refresh-credit">
                                                            <span>
                                                                <b>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={25}
                                                                        height={25}
                                                                        fill="currentColor"
                                                                        className={this.state.checkcredit ? "text-black bi bi-arrow-clockwise circle-svg" : "text-black bi bi-arrow-clockwise"}
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path
                                                                            fillRule="evenodd"
                                                                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                                        />
                                                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                                    </svg>
                                                                </b>
                                                            </span>
                                                        </a>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3 pl-0 pt-2 text-right">
                                            <a>
                                                <div className="text-white-credit-balance">
                                                    คะแนน{" "}
                                                    <div>
                                                        <span id="Mcpoint">
                                                            <img
                                                                className="w-point"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f66dab6a-2457-48b6-6b53-350397d50400/public"
                                                                alt=""
                                                            />{" "}
                                                            {this.state.point}
                                                        </span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                    </div>
                                    <div className="text-white-credit-balance" style={{ display: this.state.loginstate ? "" : "none" }} >
                                        <div className="row m-0">
                                            <div className="col-12 mb-2">
                                                <div className="d-flex justify-content-between pb-1" id="progress">
                                                    <small><NumericFormat value={rankob && rankob.lowamount} displayType={'text'} thousandSeparator={true} /> </small>
                                                    <small>
                                                        {" "}
                                                        (ยอดฝากรวม <span id="total_deposit">0</span> ฿ / 0%){" "}
                                                        <span >
                                                            <img
                                                                className="img-fluid -profile-image"
                                                                src={"/build/rank/" + this.state.rankpic}
                                                                alt="customer image"
                                                                width={43}
                                                            />{" "}
                                                        </span>
                                                    </small>
                                                    <small id="max_deposit"> <NumericFormat value={rankob && rankob.highamount} displayType={'text'} thousandSeparator={true} /> </small>
                                                </div>
                                                <div className="progress progress-sm">
                                                    <div
                                                        className="progress-bar"
                                                        role="progressbar"
                                                        id="progress_bar"
                                                        aria-valuemin={0}
                                                        aria-valuemax={0}
                                                        style={{ width: "0%" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col p-1">
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/deposit")
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    className="btn btn-success btn-lg btn-block w-100 p-1">
                                                    <small>
                                                        <b>ฝากเงิน</b>
                                                    </small>
                                                </a>
                                            </div>
                                            <div className="col p-1">
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/withdraw")
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    className="btn btn-danger btn-lg btn-block w-100 p-1">
                                                    <small>
                                                        <b>ถอนเงิน</b>
                                                    </small>
                                                </a>
                                            </div>
                                            <div className="col p-1">
                                                <a
                                                    onClick={(e) => {
                                                        this.checkurl(e, "/statement")
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    className="btn btn-primary btn-lg btn-block w-100 p-1">
                                                    <small>
                                                        <b>ประวัติ</b>
                                                    </small>
                                                </a>
                                            </div>
                                            {/**/}
                                        </div>
                                    </div>
                                    <div className="mt-3" style={{ display: tabselect == 1 ? "" : "none" }} >
                                        <div className="x-login-index animated animatedFadeInUp fadeInUp p-2">
                                            <div className="container">
                                                <h5 className="mt-1 text-left text-type">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={20}
                                                        height={20}
                                                        fill="currentColor"
                                                        className="bi bi-bank2"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
                                                    </svg>{" "}
                                                    ประเภทการฝากเงิน
                                                </h5>
                                                <div className="row">
                                                    <div className="col-12 mb-2 p-1" style={{ display: paymentbool ? "" : "none" }}>
                                                        <a onClick={(e) => {
                                                            this.checktab(e, 220)
                                                        }}>
                                                            <img
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/21c09030-ae4c-4f98-7ba0-e84a51719a00/public"
                                                                className="w-100 img-deposit"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-12 mb-2 p-1" style={{ display: mainacc !== null && mainacc !== undefined && mainacc !== '' && mainacc.length > 0 ? "" : "none" }}>
                                                        <a onClick={(e) => {
                                                            this.checktab(e, 200)
                                                        }}>
                                                            <img
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ccb29b02-ab04-4d4b-a42b-2e4fe509c600/public"
                                                                className="w-100 img-deposit"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="col-12 mb-2 p-1" >
                                                        <a onClick={(e) => {
                                                            this.checktab(e, 210)
                                                        }}>
                                                            <img
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/4f0b9968-5a51-4d56-56a6-a2d5796f6a00/public"
                                                                className="w-100 img-deposit"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>

                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3" style={{ display: tabselect == 2 ? "" : "none" }}>
                                        <div className="x-login-index animated animatedFadeInUp fadeInUp p-2">
                                            <div className="container">
                                                <h5 className="mt-1 text-left text-type">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={20}
                                                        height={20}
                                                        fill="currentColor"
                                                        className="bi bi-bank2"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
                                                    </svg>{" "}
                                                    ประเภทการถอนเงิน
                                                </h5>
                                                <div className="row">
                                                    <div className="col-12 mb-2 p-1">
                                                        <a onClick={(e) => {
                                                            this.checktab(e, 230)
                                                        }}>
                                                            <img
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d71a2069-6fb5-4bf5-2679-a1dd9cf0fb00/public"
                                                                className="w-100 img-deposit"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 mb-2 p-1">
                                                        <a onClick={(e) => {
                                                            this.checktab(e, 230)
                                                        }}>
                                                            <img
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/694ac4ec-d688-46cc-fb1f-31b3bc366100/public"
                                                                className="w-100 img-deposit"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="x-margin-top-v3" style={{ display: tabselect == 3 ? "" : "none" }}>
                                        <div className="animated animatedFadeInUp fadeInUp p-2">
                                            <div className="p-0 container animated animatedFadeInUp fadeInUp text-center">
                                                <div className="row m-0 text-center">
                                                    <div className="col-12 p-0">
                                                        <div className="text-left mb-3">
                                                            <div className="-inner-wrapper text-left">
                                                                <h3 className="x-title-modal mx-auto text-center">
                                                                    <b>รายการธุรกรรมการเงิน</b>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 p-2 text-center">
                                                        <div
                                                            data-v-02098bde=""
                                                            data-v-28a2bed6=""
                                                            className="tourneys__tabs row text-center"
                                                        >
                                                            <button
                                                                data-v-47c7b004=""
                                                                data-v-28a2bed6=""
                                                                type="button"
                                                                className="active button-tab button-tab_md button-tab_blue pl-3 pr-3 col-4 text-center"
                                                            >
                                                                <span
                                                                    data-v-47c7b004=""
                                                                    data-v-28a2bed6=""
                                                                    className="pl-4-pr-4"
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-wallet2"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
                                                                    </svg>{" "}
                                                                    ทั้งหมด
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div
                                                            data-v-ab1d19ba=""
                                                            className="auction-list animated animatedFadeInUp fadeInUp text-white-v1"
                                                        >
                                                            <div style={{ display: (this.state.historylist.length === 0) ? "" : "none" }} >
                                                                <div>
                                                                    <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                                        <b>
                                                                            <img
                                                                                className="load-history"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                alt=""
                                                                            />
                                                                            <div className="not-history font-history-menu-text p-2">
                                                                                <small>
                                                                                    <b>ไม่พบรายการ...</b>
                                                                                </small>
                                                                            </div>
                                                                        </b>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                style={{ display: (this.state.historylist.length === 0) ? "none" : "" }}
                                                                data-v-ab1d19ba=""
                                                                className="auction-list animated animatedFadeInUp fadeInUp text-white-v1"
                                                            >
                                                                <div data-v-0bcfa847="" data-v-ab1d19ba="">
                                                                    <div data-v-0bcfa847="" className="list__head">
                                                                        <span data-v-0bcfa847="">ประวัติทำรายการ </span>
                                                                        <span data-v-0bcfa847="">เวลา </span>
                                                                        <span data-v-0bcfa847="">จำนวนเงิน </span>
                                                                    </div>
                                                                    <div>
                                                                        {this.state.historylist.map((listitem, i) => (

                                                                            <div data-v-0bcfa847="" key={i} className="list__inner">
                                                                                <div>
                                                                                    <div data-v-0bcfa847="" className="list-item">
                                                                                        <div data-v-0bcfa847="" className="list-item__user">
                                                                                            <div data-v-0bcfa847="" className="item-user">
                                                                                                <div
                                                                                                    data-v-b41a49a6=""
                                                                                                    data-v-0bcfa847=""
                                                                                                    className="user item-user__userpick user--clickable"
                                                                                                >
                                                                                                    <div data-v-b41a49a6="" className="user__wrap" />
                                                                                                </div>
                                                                                                <span
                                                                                                    data-v-0bcfa847=""
                                                                                                    className={(listitem.type === "BN") ? "*โบนัส" : (listitem.type === "DE") ? "item-user__betsize text-success" : "item-user__betsize text-danger"}                                                                                              >
                                                                                                    <h5 className="m-0 font-list-history">{(listitem.type === "BN") ? "*โบนัส" : (listitem.type === "DE") ? "ฝากเงิน" : "ถอนเงิน"}</h5>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div data-v-0bcfa847="" className="list-item__user">
                                                                                            <div data-v-0bcfa847="" className="item-user">
                                                                                                <div
                                                                                                    data-v-b41a49a6=""
                                                                                                    data-v-0bcfa847=""
                                                                                                    className="user item-user__userpick user--clickable"
                                                                                                >
                                                                                                    <div data-v-b41a49a6="" className="user__wrap" />
                                                                                                </div>
                                                                                                <span data-v-0bcfa847="" className="item-user__name">
                                                                                                    {moment(listitem.createdate).format('DD/MM/YY') + " - " + moment(listitem.createdate).format('HH:mm') + " น."}
                                                                                                </span>
                                                                                                <span
                                                                                                    data-v-0bcfa847=""
                                                                                                    className="item-user__betsize text-success"
                                                                                                >
                                                                                                    <div style={{ display: (listitem.status === "2") ? "" : "none" }}>
                                                                                                        <span className="-state-text">สถานะ : </span>
                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-counterclockwise text-warning" viewBox="0 0 16 16"><path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"></path><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"></path></svg>
                                                                                                        {" "} <span className="-state-title text-warning">กำลังดำเนินการ</span>
                                                                                                    </div>
                                                                                                    <div style={{ display: (listitem.status === "0") ? "" : "none" }}>
                                                                                                        <span className="-state-text">สถานะ : </span>
                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-counterclockwise text-warning" viewBox="0 0 16 16"><path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"></path><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"></path></svg>
                                                                                                        {" "} <span className="-state-title text-warning">รอดำเนินการ</span>
                                                                                                    </div>
                                                                                                    <div style={{ display: (listitem.status === "4") ? "" : "none" }}>
                                                                                                        <span className="-state-text">สถานะ : </span>
                                                                                                        <img
                                                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                                                            className="-ic"
                                                                                                            width="16" height="16"
                                                                                                            alt=""
                                                                                                        />
                                                                                                        {" "}
                                                                                                        <span className="-state-title">ยกเลิก (ยกเลิกโดยผู้เล่น)</span>
                                                                                                    </div>
                                                                                                    <div style={{ display: (listitem.status === "5") ? "" : "none" }}>
                                                                                                        <span className="-state-text">สถานะ : </span>
                                                                                                        <img
                                                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                                                            className="-ic"
                                                                                                            width="16" height="16"
                                                                                                            alt=""
                                                                                                        />
                                                                                                        {" "}
                                                                                                        <span className="-state-title">ไม่สำเร็จ (โดยระบบ)</span>
                                                                                                    </div>
                                                                                                    <div style={{ display: (listitem.status === "1") ? "" : "none" }}>
                                                                                                        <span className="-state-text">สถานะ : </span>
                                                                                                        <img
                                                                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                                                            className="-ic"
                                                                                                            width="16" height="16"
                                                                                                            alt=""
                                                                                                        />
                                                                                                        {" "}
                                                                                                        <span className="-state-title">สำเร็จ</span>
                                                                                                    </div>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div data-v-0bcfa847="" className="list-item__expected">
                                                                                            <div data-v-0bcfa847="" className="currency">
                                                                                                <span data-v-0bcfa847="">
                                                                                                    <span
                                                                                                        className={(listitem.type === "DE") ? "font-digits text-success" : "font-digits text-danger"}
                                                                                                        style={{ color: "rgb(255, 255, 255)", fontSize: 22 }}
                                                                                                    >
                                                                                                        {listitem.amount}
                                                                                                    </span>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 top-loss x-margin-top-v3" style={{ display: tabselect == 4 ? "" : "none" }}>
                                        <div className="m-0 border-shadow-title">
                                            <div>
                                                <div
                                                    className="d-flex justify-content-between p-1 text-color bg-refer-title"
                                                    style={{ width: "100%", overflowX: "scroll" }}
                                                >
                                                    <div className="active-tap-hover">
                                                        <div
                                                            onClick={(e) => {
                                                                this.checkurl(e, '/refer/overview')
                                                            }}
                                                            role="button"
                                                            className={this.state.refer == 1 ? "text-color p-1 rounded-pill w-width-tap active-refer" : "text-color p-1 rounded-pill w-width-tap"}
                                                        >
                                                            <div data-v-ab1d19ba="" className="auction-width">
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="auction__body-menu auction__body--border-radius"
                                                                >
                                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                                        <div
                                                                            data-v-00ef951c=""
                                                                            className="auction-pool-menu text-center"
                                                                        >
                                                                            <span className="text-size-menu-casino">
                                                                                <b>ภาพรวม</b>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="active-tap-hover">
                                                        <div
                                                            onClick={(e) => {
                                                                this.checkurl(e, '/refer/member')
                                                            }}
                                                            role="button"
                                                            //className="text-color p-1 rounded-pill w-width-tap"
                                                            className={this.state.refer == 2 ? "text-color p-1 rounded-pill w-width-tap active-refer" : "text-color p-1 rounded-pill w-width-tap"}
                                                        >
                                                            <div data-v-ab1d19ba="" className="auction-width">
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="auction__body-menu auction__body--border-radius"
                                                                >
                                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                                        <div
                                                                            data-v-00ef951c=""
                                                                            className="auction-pool-menu text-center"
                                                                        >
                                                                            <span className="text-size-menu-casino">
                                                                                <b>สมาชิก</b>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="active-tap-hover">
                                                        <div
                                                            onClick={(e) => {
                                                                this.checkurl(e, '/refer/income-summary')
                                                            }}
                                                            role="button"
                                                            // className="text-color p-1 rounded-pill w-width-tap"
                                                            className={this.state.refer == 3 ? "text-color p-1 rounded-pill w-width-tap active-refer" : "text-color p-1 rounded-pill w-width-tap"}
                                                        >
                                                            <div data-v-ab1d19ba="" className="auction-width">
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="auction__body-menu auction__body--border-radius"
                                                                >
                                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                                        <div
                                                                            data-v-00ef951c=""
                                                                            className="auction-pool-menu text-center"
                                                                        >
                                                                            <span className="text-size-menu-casino">
                                                                                <b>สรุปรายได้</b>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="active-tap-hover">
                                                        <div
                                                            onClick={(e) => {
                                                                this.checkurl(e, '/refer/share-network')
                                                            }}
                                                            role="button"
                                                            className={this.state.refer == 4 ? "text-color p-1 rounded-pill w-width-tap active-refer" : "text-color p-1 rounded-pill w-width-tap"}
                                                        >
                                                            <div data-v-ab1d19ba="" className="auction-width">
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="auction__body-menu auction__body--border-radius"
                                                                >
                                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                                        <div
                                                                            data-v-00ef951c=""
                                                                            className="auction-pool-menu text-center"
                                                                        >
                                                                            <span className="text-size-menu-casino">
                                                                                <b>เครือข่าย</b>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="container mb-5 mt-2">
                                            <div className="p-2 bg-profile-box-overview" style={{ display: tabselect == 4 && this.state.refer == 1 ? "" : "none" }}>
                                                <div className="animated animatedFadeInUp fadeInUp mt-2">
                                                    <div className="bg-profile-box-overview p-2">
                                                        <div className="d-flex justify-content-between row m-0 align-items-center">
                                                            <div className="col-12 col-md-12 p-0">
                                                                <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                    <div className="align-self-center">
                                                                        <div className="p-1 text-left">
                                                                            <div>
                                                                                <h3 className="m-0">
                                                                                    <b className="p-1">0.00</b>
                                                                                </h3>
                                                                            </div>
                                                                            <small>รายได้จากเครือข่าย ทั้งหมด</small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center text-right">
                                                                        <div>
                                                                            <span className="badge text-bg-dark">0.00%</span>
                                                                        </div>
                                                                        <div>
                                                                            <span className="font-play-text">จากเดือนที่แล้ว</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="pt-2">
                                                        <div className="row m-0">
                                                            <div className="col-12 col-md-12 p-1">
                                                                <div className="d-flex justify-content-between financial-button">
                                                                    <div
                                                                        role="button"
                                                                        className="align-self-center p-1 credit-bl-text"
                                                                    >
                                                                        <div role="button" className="financial-button-r">
                                                                            <div className="d-flex justify-content-start">
                                                                                <div className="align-self-center">
                                                                                    <img
                                                                                        className="logo-profile-user-w p-1"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/48a22d9a-8abe-477f-0f40-57204ce17700/public"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="align-self-center">
                                                                                    <div className="username-profile">
                                                                                        <small>รายได้ที่ถอนได้ </small>
                                                                                    </div>
                                                                                    <div className="username-profile">
                                                                                        <small>
                                                                                            <b className="font-aff-wid">{tblprofile.AffiliateCash}</b>
                                                                                        </small>
                                                                                        <a
                                                                                            role="button"
                                                                                            className="text-white-credit-balance p-1"
                                                                                            id="icon-refresh-credit"
                                                                                        >
                                                                                            <span>
                                                                                                <b>
                                                                                                    <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        width={18}
                                                                                                        height={18}
                                                                                                        fill="currentColor"
                                                                                                        className="text-white bi bi-arrow-clockwise"
                                                                                                        viewBox="0 0 16 16"
                                                                                                    >
                                                                                                        <path
                                                                                                            fillRule="evenodd"
                                                                                                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                                                                        />
                                                                                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                                                                    </svg>
                                                                                                </b>
                                                                                            </span>
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center">
                                                                        <a role="button"
                                                                            onClick={(e) => {
                                                                                this.opencliaminvite(e, 'bonusrankaccount')
                                                                            }}>
                                                                            <div className="bg-text-highlight pd-bl-aff">
                                                                                <div
                                                                                    disabled="false"
                                                                                    role="button"
                                                                                    className="btn -submit js-submit-accept-term v-login mt-lg-1 mt-0 w-100 p-2"
                                                                                >
                                                                                    <img
                                                                                        className="wid-button p-1"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/de26db72-10a7-4369-5e7e-dd07d4568300/public"
                                                                                        alt=""
                                                                                    />
                                                                                    <span> ถอนรายได้ </span>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row m-0 mt-2">
                                                            <div className="col-6 p-0">
                                                                <div className="elementor-element-play-overview p-2 m-1">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <img
                                                                                    className="icon-aff"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5e4ede40-9f30-4c50-5278-136b8e2e0900/public"
                                                                                    alt=""
                                                                                />
                                                                                <div>
                                                                                    <h3 className="m-0">
                                                                                        <b>0</b>
                                                                                    </h3>
                                                                                </div>
                                                                                <small role="button">จำนวนคลิกลิงค์ทั้งหมด</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div>
                                                                                    <small className="font-play-text">
                                                                                        จากเดือนที่แล้ว
                                                                                    </small>
                                                                                </div>
                                                                                <span className="badge text-bg-dark">0.00 %</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 p-0">
                                                                <div className="elementor-element-play-overview p-2 m-1">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <img
                                                                                    className="icon-aff"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a7961b16-c14d-495f-3d2f-c7ea12ab2c00/public"
                                                                                    alt=""
                                                                                />
                                                                                <div>
                                                                                    <h3 className="m-0">
                                                                                        <b>0</b>
                                                                                    </h3>
                                                                                </div>
                                                                                <small role="button">จำนวนสมาชิกทั้งหมด</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div>
                                                                                    <small className="font-play-text">
                                                                                        จากเดือนที่แล้ว
                                                                                    </small>
                                                                                </div>
                                                                                <span className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div onClick={(e) => {
                                                            this.checkurl(e, '/refer/member')
                                                        }} className="d-flex justify-content-between pt-2 pb-2">
                                                            <div role="button"

                                                                className="align-self-center">
                                                                <img
                                                                    className="icon-profile-title-left"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f8270235-43e5-4c38-247d-98b9ebfbe700/public"
                                                                    alt=""
                                                                />
                                                                <small>
                                                                    <b>&nbsp;สมาชิกใหม่วันนี้</b>
                                                                </small>
                                                            </div>
                                                            <div className="align-self-center">{this.state.afficiatetoday.length} คน </div>
                                                        </div>
                                                        <hr className="m-0 color-hr" />
                                                        <div onClick={(e) => {
                                                            this.checkurl(e, '/statement')
                                                        }} className="d-flex justify-content-between pt-2 pb-2">
                                                            <div role="button"

                                                                className="align-self-center">
                                                                <img
                                                                    className="icon-profile-title-left"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f8270235-43e5-4c38-247d-98b9ebfbe700/public"
                                                                    alt=""
                                                                />
                                                                <small>
                                                                    <b>&nbsp;ประวัติ</b>
                                                                </small>
                                                            </div>
                                                            <div className="align-self-center">
                                                                <img
                                                                    className="goto-financial"
                                                                    role="button"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ad650691-9c48-4cb9-6e44-36d5d1eaf700/public"
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                        <hr className="m-0 color-hr" />
                                                        <div onClick={(e) => {
                                                            this.checkurl(e, '/refer/share-network')
                                                        }} className="d-flex justify-content-between pt-2 pb-2">
                                                            <div

                                                                role="button" className="align-self-center">
                                                                <img
                                                                    className="icon-profile-title-left"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f8270235-43e5-4c38-247d-98b9ebfbe700/public"
                                                                    alt=""
                                                                />
                                                                <small>
                                                                    <b>&nbsp;วิธีการสร้างเครือข่าย </b>
                                                                </small>
                                                            </div>
                                                            <div className="align-self-center">
                                                                <img
                                                                    className="goto-financial"
                                                                    role="button"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ad650691-9c48-4cb9-6e44-36d5d1eaf700/public"
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-2 animated animatedFadeInUp fadeInUp">
                                                    <div className="mt-2 mb-2">
                                                        <img
                                                            className="icon-profile-title-left"
                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/81deef6a-eb5d-4bf2-221c-3b85586ca700/public"
                                                            alt=""
                                                        />
                                                        <small className="pt-2 pb-2">
                                                            <b>&nbsp; ลิงก์เชิญชวน</b>
                                                        </small>
                                                    </div>
                                                    <div className="bg-color-financial-my-bank bg-profile-box-overview">
                                                        <div className="d-flex justify-content-between pt-3 pb-3">
                                                            <div>
                                                                <small>คัดลอก</small>
                                                                <div>
                                                                </div>

                                                            </div>
                                                            {linkaff && linkaff !== null ?
                                                                <a style={{ cursor: "pointer" }} onClick={(e) => this.copy(e, linkaff)}>

                                                                    <small className="font-play-text">
                                                                        <b>
                                                                            <small id="copy-ShareLink">
                                                                                {linkaff}
                                                                            </small>
                                                                            <img
                                                                                role="button"
                                                                                className="icon-profile-title-left"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/270b7b9f-b130-414c-b2a8-dfe9ecb9cc00/public"
                                                                                alt=""
                                                                            />
                                                                        </b>
                                                                    </small>

                                                                </a>
                                                                : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/**/}
                                                {/**/}
                                                {/**/}
                                            </div>
                                            <div className="p-2 bg-profile-box-overview" style={{ display: tabselect == 4 && this.state.refer == 2 ? "" : "none" }}>
                                                <div className="animated animatedFadeInUp fadeInUp">
                                                    <div className="box-number text-center">
                                                        <div>
                                                            <div className="bg-profile-box-overview p-2 mb-2">
                                                                <div className="d-flex justify-content-between row m-0 align-items-center">
                                                                    <div className="col-12 col-md-12 p-0">
                                                                        <div
                                                                            className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                            <div className="align-self-center">
                                                                                <div className="p-1 text-left"><small><img className="icon-aff"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/84f8435d-3a19-4e45-eb3c-57f582263300/public"
                                                                                    alt="" /> ยอดแอคทีฟทั้งหมด</small>
                                                                                    <div><label className="m-0 font-member-aff-all"><b className="p-1">{this.state.afficiatetoday.length}</b></label> คน </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="align-self-center text-right">
                                                                                <div><span className="badge text-bg-dark">{this.state.afficiatetoday.length} </span></div>
                                                                                <div><span className="font-play-text text_aff_affiliate">สมัครวันนี้</span></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <table className="table">
                                                                        <tbody>
                                                                            {this.state.afficiatetoday.map((listitem, i) => (
                                                                                <tr className="text-center cl-mod-1">
                                                                                    <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                        alt="" /></td>
                                                                                    <td className="text-left p-1-aff text_aff_affiliate"><b>{i + 1}</b></td>
                                                                                    <td className="text-left p-1-aff text_aff_affiliate">{listitem.playerid}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>

                                                                    </table>
                                                                </div>
                                                                <div className="col-12"><canvas id="acquisitions" style={{
                                                                    display: 'block', boxSizing: 'border-box',
                                                                }} />
                                                                </div>
                                                                <div className="d-flex justify-content-between scroll-title-history-aff align-items-center mb-1 mt-1">
                                                                    <div><a className="btn btn-outline-secondary text_aff_affiliate_tab text_aff_affiliate_tab_active"
                                                                        role="button">วันนี้</a></div>
                                                                    <div><a className="btn btn-outline-secondary text_aff_affiliate_tab" role="button">7 วันที่เเล้ว</a></div>
                                                                    <div><a className="btn btn-outline-secondary text_aff_affiliate_tab" role="button">เดือนที่เเล้ว</a></div>
                                                                    <div><a className="btn btn-outline-secondary text_aff_affiliate_tab" role="button">ทั้งหมด</a></div>
                                                                </div>
                                                            </div>
                                                            <div className="row m-0">
                                                                <div className="col-12 col-md-6 p-1">
                                                                    <div className="elementor-element-play-overview p-2">
                                                                        <div className="d-flex justify-content-between text-center">
                                                                            <div className="align-self-center">
                                                                                <div className="p-1 text-left"><img className="icon-aff"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                    alt="" /> LV 1 <div><b className="m-0 font-member-aff">{this.state.afficiatetoday.length} </b><small className="text_aff_affiliate">
                                                                                        คน</small></div><small className="text_aff_affiliate">แนะนำสมาชิกทั้งหมด</small></div>
                                                                            </div>
                                                                            <div className="align-self-center text-right">
                                                                                <div>
                                                                                    <div><small className="font-play-text text_aff_affiliate">จากเดือนที่แล้ว</small></div><span
                                                                                        className="badge text-bg-dark">0.00%</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="col-12 col-md-6 p-1">
                                                                <div className="elementor-element-play-overview p-2">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left"><img className="icon-aff"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                alt="" /> LV 2 <div><b className="m-0 font-member-aff">0</b><small className="text_aff_affiliate">
                                                                                    คน</small></div><small className="text_aff_affiliate">แนะนำสมาชิกทั้งหมด</small></div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div><small className="font-play-text text_aff_affiliate">จากเดือนที่แล้ว</small></div><span
                                                                                    className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-6 p-1">
                                                                <div className="elementor-element-play-overview p-2">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left"><img className="icon-aff"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                alt="" /> LV 3 <div><b className="m-0 font-member-aff">0</b><small className="text_aff_affiliate">
                                                                                    คน</small></div><small className="text_aff_affiliate">แนะนำสมาชิกทั้งหมด</small></div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div><small className="font-play-text text_aff_affiliate">จากเดือนที่แล้ว</small></div><span
                                                                                    className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-6 p-1">
                                                                <div className="elementor-element-play-overview p-2">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left"><img className="icon-aff"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                alt="" /> LV 4 <div><b className="m-0 font-member-aff">0</b><small className="text_aff_affiliate">
                                                                                    คน</small></div><small className="text_aff_affiliate">แนะนำสมาชิกทั้งหมด</small></div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div><small className="font-play-text text_aff_affiliate">จากเดือนที่แล้ว</small></div><span
                                                                                    className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-6 p-1">
                                                                <div className="elementor-element-play-overview p-2">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left"><img className="icon-aff"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                alt="" /> LV 5 <div><b className="m-0 font-member-aff">0</b><small className="text_aff_affiliate">
                                                                                    คน</small></div><small className="text_aff_affiliate">แนะนำสมาชิกทั้งหมด</small></div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div><small className="font-play-text text_aff_affiliate">จากเดือนที่แล้ว</small></div><span
                                                                                    className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            </div>
                                                            <div className="bg-profile-box-overview p-2 mb-2 mt-2">
                                                                <div className="d-flex justify-content-between row m-0 align-items-center">
                                                                    <div className="col-12 col-md-12 p-0">
                                                                        <div
                                                                            className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                            <div className="align-self-center">
                                                                                <div className="p-1 text-left"><small className="text_aff_affiliate">ยอดการเล่นทุกประเภท</small>
                                                                                    <div><label className="m-0"><b className="p-1">0 คน</b></label></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <table className="table">
                                                                <tbody>
                                                                    <tr className="text-center cl-mod-1">
                                                                        <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt="" /></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate"><b>ลำดับที่ 1</b></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">0</td>
                                                                        <td className="p-1-aff text_aff_affiliate">คน</td>
                                                                    </tr>
                                                                    <tr className="text-center cl-mod-2">
                                                                        <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt="" /></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate"><b>ลำดับที่ 2</b></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">0</td>
                                                                        <td className="p-1-aff text_aff_affiliate">คน</td>
                                                                    </tr>
                                                                    <tr className="text-center cl-mod-1">
                                                                        <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt="" /></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate"><b>ลำดับที่ 3</b></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">0</td>
                                                                        <td className="p-1-aff text_aff_affiliate">คน</td>
                                                                    </tr>
                                                                    <tr className="text-center cl-mod-2">
                                                                        <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt="" /></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate"><b>ลำดับที่ 4</b></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">0</td>
                                                                        <td className="p-1-aff text_aff_affiliate">คน</td>
                                                                    </tr>
                                                                    <tr className="text-center cl-mod-1">
                                                                        <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt="" /></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate"><b>ลำดับที่ 5</b></td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">0</td>
                                                                        <td className="p-1-aff text_aff_affiliate">คน</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table> */}
                                                            </div>
                                                            <div className="d-flex justify-content-between pt-2 pb-2">
                                                                <div role="button" className="align-self-end"><small><b>&nbsp;รายละเอียกเครือข่าย</b></small></div>
                                                            </div>
                                                            <div className="bg-profile-box-overview p-2 mb-2">
                                                                <table className="table">
                                                                    <thead className="table-dark-history">
                                                                        <tr className="bg-table-dark-history-title">
                                                                            <td className="credit-bl-text text_aff_affiliate"><small>วันที่</small></td>
                                                                            <td className="credit-bl-text text_aff_affiliate"><small>ยอดถอน</small></td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr className="bg-table-dark-history">
                                                                            <td colSpan={2} className="text-white text-center">
                                                                                <div>
                                                                                    <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                                        className="load-history"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                        alt="" />
                                                                                        <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                                    </b></div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-2 bg-profile-box-overview" style={{ display: tabselect == 4 && this.state.refer == 3 ? "" : "none" }}>
                                                <div className="animated animatedFadeInUp fadeInUp">
                                                    <div className="align-self-center">
                                                        <div className="p-1 text-left"><label>สรุปรายได้ทั้งหมด</label></div>
                                                    </div>
                                                    <div className="bg-profile-box-overview p-2 mb-2">
                                                        <div className="d-flex justify-content-between row m-0 align-items-center">
                                                            <div className="col-12 col-md-12 p-0">
                                                                <div
                                                                    className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                    <div className="align-self-center">
                                                                        <div className="p-1 text-left">
                                                                            <div><small className="text_aff_affiliate">รายได้จากเครือข่าย ทั้งหมด</small>
                                                                                <h3 className="m-0"><b className="p-1">0.00</b></h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center text-right">
                                                                        <div><span className="badge text-bg-dark">0.00%</span></div>
                                                                        <div><span className="font-play-text text_aff_affiliate">จากเดือนที่แล้ว</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="pt-2">
                                                            <div className="row m-0">
                                                                <div className="col-12 col-md-12 p-1">
                                                                    <div className="d-flex justify-content-between financial-button">
                                                                        <div role="button" className="align-self-center p-1 credit-bl-text">
                                                                            <div role="button" className="financial-button-r">
                                                                                <div className="d-flex justify-content-start">
                                                                                    <div className="align-self-center"><img className="logo-profile-user-w p-1"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/48a22d9a-8abe-477f-0f40-57204ce17700/public"
                                                                                        alt="" /></div>
                                                                                    <div className="align-self-center">
                                                                                        <div className="username-profile"><small>รายได้ที่ถอนได้ </small></div>
                                                                                        <div className="username-profile"><small><b className="font-aff-wid">0.00</b></small><a
                                                                                            role="button" className="text-white-credit-balance p-1" id="icon-refresh-credit"><span><b><svg
                                                                                                xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="currentColor"
                                                                                                className="text-white bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                                                                <path fillRule="evenodd"
                                                                                                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                                                                <path
                                                                                                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                                                            </svg></b></span></a></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="bg-profile-box-overview p-2 mb-2">
                                                        <div className="d-flex justify-content-between row m-0 align-items-center">
                                                            <div className="col-12 col-md-12 p-0">
                                                                <div
                                                                    className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl">
                                                                    <div className="align-self-center">
                                                                        <div className="p-1 text-left">
                                                                            <div><img className="icon-aff-member"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/db83e83e-f021-468d-995c-c10ebf09fb00/public"
                                                                                alt="" /><small className="text_aff_affiliate"> ค้นหาที่มารายได้</small></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row text-center m-0">
                                                            <div className="col-12 col-md-6 p-1"><select className="form-control option-search-aff"
                                                                style={{ textAlign: 'center' }}>
                                                                <option value="all">ทุกเลเวล</option>
                                                                <option value="lv1">level 1</option>
                                                                <option value="lv2">level 2</option>
                                                                <option value="lv3">level 3</option>
                                                                <option value="lv5">level 5</option>
                                                            </select></div>
                                                            <div className="col-12 col-md-6 p-1"><select className="form-control option-search-aff"
                                                                style={{ textAlign: 'center' }}>
                                                                <option value="all">ทุกประเภท</option>
                                                                <option value="slot">สล็อต</option>
                                                                <option value="casino">คาสิโน</option>
                                                                <option value="winloss">ยอดเสีย</option>
                                                            </select></div>
                                                            <div className="col-12 col-md-12 p-1 text-left">
                                                                <div className="input-group"><input type="text"
                                                                    className="form-control bg-income-summary text-center-s-date font-play-text" placeholder="วันนี้ — วันนี้"
                                                                    aria-label="วันนี้ — วันนี้" disabled aria-describedby="basic-addon2" /><span role="button"
                                                                        className="input-group-text" id="basic-addon2"><svg xmlns="http://www.w3.org/2000/svg" width={16}
                                                                            height={16} fill="currentColor" className="bi bi-calendar" viewBox="0 0 16 16">
                                                                            <path
                                                                                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                                        </svg></span></div>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="row text-center">
                                                                    <div className="col-12 col-md-6 p-1">
                                                                        <div role="button" className="affiliate-aff-search p-2"><label className="font-play-text">ล้างค่า</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 col-md-6 p-1">
                                                                        <div role="button" className="affiliate-aff-search-submit p-2"><label>ค้นหา</label></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="credit-bl-text pb-2"><span><small>คุณกำลังดูช่วงเวลา &nbsp; </small></span></div>
                                                    <div className="bg-profile-box-overview p-2 mb-2">
                                                        <div className="d-flex justify-content-between pb-2">
                                                            <div className="d-flex justify-content-start align-items-center">
                                                                <div className="p-2"><img className="icon-aff-member"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public" alt="" />
                                                                </div>
                                                                <div>
                                                                    <div>
                                                                        <h5 className="credit-bl-text"><b>ระดับที่ 1</b></h5>
                                                                    </div>
                                                                    <div><small className="text_aff_affiliate">รายละเอียดการทำรายได้</small></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <table className="table mb-0">
                                                            <thead className="table-dark-history">
                                                                <tr className="bg-table-dark-history-title">
                                                                    <td className="credit-bl-text text_aff_affiliate text-center"><small>ประเภท</small></td>
                                                                    <td className="credit-bl-text text_aff_affiliate text-center"><small>ยอดแทง</small></td>
                                                                    <td className="credit-bl-text text_aff_affiliate text-center"><small>รายได้</small></td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="bg-table-dark-history">
                                                                    <td colSpan={3} className="text-white text-center">
                                                                        <div>
                                                                            <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                                className="load-history"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                alt="" />
                                                                                <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                            </b></div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {/* <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between pb-2">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div className="p-2"><img className="icon-aff-member"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public" alt="" />
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <h5 className="credit-bl-text"><b>ระดับที่ 2</b></h5>
                                                                </div>
                                                                <div><small className="text_aff_affiliate">รายละเอียดการทำรายได้</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table className="table mb-0">
                                                        <thead className="table-dark-history">
                                                            <tr className="bg-table-dark-history-title">
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ประเภท</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ยอดแทง</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>รายได้</small></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="bg-table-dark-history">
                                                                <td colSpan={3} className="text-white text-center">
                                                                    <div>
                                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                            className="load-history"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                            alt="" />
                                                                            <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                        </b></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between pb-2">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div className="p-2"><img className="icon-aff-member"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public" alt="" />
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <h5 className="credit-bl-text"><b>ระดับที่ 3</b></h5>
                                                                </div>
                                                                <div><small className="text_aff_affiliate">รายละเอียดการทำรายได้</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table className="table mb-0">
                                                        <thead className="table-dark-history">
                                                            <tr className="bg-table-dark-history-title">
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ประเภท</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ยอดแทง</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>รายได้</small></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="bg-table-dark-history">
                                                                <td colSpan={3} className="text-white text-center">
                                                                    <div>
                                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                            className="load-history"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                            alt="" />
                                                                            <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                        </b></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between pb-2">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div className="p-2"><img className="icon-aff-member"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public" alt="" />
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <h5 className="credit-bl-text"><b>ระดับที่ 4</b></h5>
                                                                </div>
                                                                <div><small className="text_aff_affiliate">รายละเอียดการทำรายได้</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table className="table mb-0">
                                                        <thead className="table-dark-history">
                                                            <tr className="bg-table-dark-history-title">
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ประเภท</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ยอดแทง</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>รายได้</small></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="bg-table-dark-history">
                                                                <td colSpan={3} className="text-white text-center">
                                                                    <div>
                                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                            className="load-history"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                            alt="" />
                                                                            <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                        </b></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between pb-2">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div className="p-2"><img className="icon-aff-member"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public" alt="" />
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <h5 className="credit-bl-text"><b>ระดับที่ 5</b></h5>
                                                                </div>
                                                                <div><small className="text_aff_affiliate">รายละเอียดการทำรายได้</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table className="table mb-0">
                                                        <thead className="table-dark-history">
                                                            <tr className="bg-table-dark-history-title">
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ประเภท</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>ยอดแทง</small></td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>รายได้</small></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="bg-table-dark-history">
                                                                <td colSpan={3} className="text-white text-center">
                                                                    <div>
                                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                            className="load-history"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                            alt="" />
                                                                            <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                        </b></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div> */}
                                                </div>
                                            </div>
                                            <div className="p-2 bg-profile-box-overview" style={{ display: tabselect == 4 && this.state.refer == 4 ? "" : "none" }}>

                                                <div className="animated animatedFadeInUp fadeInUp text-center">
                                                    <div className="bg-profile-box p-2">
                                                        <div>
                                                            <div className="p-2 align-self-center">
                                                                <div className="username-profile"><b>รวยง่ายๆ กับ switchbet</b></div>
                                                                <div className="username-profile"><b>แค่แชร์ลิงก์ก็สร้างรายได้</b></div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp"><b><img
                                                                    className="load-history"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                    alt="" />
                                                                    <div className="not-history font-history-menu-text p-2"><small><b>ไม่พบข้อมูล</b></small></div>
                                                                </b></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 mt-1" style={{ display: tabselect == 5 ? "" : "none" }}>
                                        <div className="m-2 border-shadow-title text-color">
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction top-loss animated animatedFadeInUp fadeInUp"
                                                role="button"
                                            >
                                                <div
                                                    data-v-ab1d19ba=""
                                                    className="auction__body-menu auction__body--border-radius"
                                                >
                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                        <h3 className="x-title-modal mx-auto text-center">
                                                            <b>คืนยอดเสีย</b>
                                                        </h3>
                                                        <hr />
                                                        {/**/}
                                                        {/**/}
                                                        <div className="d-flex justify-content-between text-center border-radius-com-head">
                                                            <div className="p-2 text-center">
                                                                <b>คืนยอดเสียสะสมทั้งหมด</b>
                                                            </div>
                                                            <div className="p-2">0</div>
                                                        </div>
                                                        <div className="d-flex justify-content-between text-center border-radius-com-head mt-2 mb-2">
                                                            <div className="p-2 text-center">
                                                                <b>คืนยอดเสียสะสมเดือนนี้</b>
                                                            </div>
                                                            <div className="p-2">0</div>
                                                        </div>
                                                        <div className="text-left"> คืนยอดเสีย slot {cashoutSet.percent}% </div>
                                                        <div className="text-left"> คืนยอดเสีย casino {cashoutSet.percent}% </div>
                                                        <div
                                                            data-v-00ef951c=""
                                                            className="auction-pool-menu-commission mt-2 mb-2"
                                                        >
                                                            <div className="p-4 text-center">
                                                                <label htmlFor="" className="">
                                                                    <h5>คืนยอดเสียของคุณ</h5>
                                                                </label>
                                                                <h5 className="text-light" style={{ fontWeight: "600" }}>{(tblprofile != null) ? tblprofile.Cashtotal : 0}</h5>
                                                            </div>
                                                        </div>
                                                        <div className="text-color">ยอดเริ่มต้น {cashoutSet.maxwithdraw} บาท</div>
                                                        <div data-v-00ef951c=""
                                                            className="auction-pool-menu">
                                                            <div className="font-income">
                                                                <div className="mt-2 mb-2">
                                                                    <button
                                                                        onClick={(e) => {
                                                                            this.opencliamcashout(e, 'bonusrankaccount')
                                                                        }}
                                                                        className="btn -submit js-submit-accept-term v-login mt-lg-1 mt-0 w-100 p-2">
                                                                        <span> เเจ้งถอนรายได้ </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-2 text-left mt-4 mb-1 text-color animated animatedFadeInUp fadeInUp">
                                                {" "}
                                                ประวัติการทำรายการ{" "}
                                            </div>
                                            <div className="animated animatedFadeInUp fadeInUp">
                                                <div>
                                                    <div>
                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                            <b>
                                                                <img
                                                                    className="load-history"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                    alt=""
                                                                />
                                                                <div className="not-history font-history-menu-text p-2">
                                                                    <small>
                                                                        <b>ไม่พบข้อมูล</b>
                                                                    </small>
                                                                </div>
                                                            </b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 mt-1" style={{ display: tabselect == 6 ? "" : "none" }}>
                                        <div className="m-2 border-shadow-title">
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction top-loss animated animatedFadeInUp fadeInUp"
                                                role="button"
                                            >
                                                <div
                                                    data-v-ab1d19ba=""
                                                    className="auction__body-menu auction__body--border-radius"
                                                >
                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                        <h3 className="x-title-modal mx-auto text-center">
                                                            <b>คืนยอดเสีย</b>
                                                        </h3>
                                                        <hr />
                                                        {/**/}
                                                        {/**/}
                                                        <div className="d-flex justify-content-between text-center border-radius-com-head">
                                                            <div className="p-2 text-center">
                                                                <b>คืนยอดเสียสะสมทั้งหมด</b>
                                                            </div>
                                                            <b className="p-1">{(tblprofile != null) ? tblprofile.Cashtotal : 0} </b>
                                                        </div>
                                                        <div className="d-flex justify-content-between text-center border-radius-com-head mt-2 mb-2">
                                                            <div className="p-2 text-center">
                                                                <b>คืนยอดเสียสะสมเดือนนี้</b>
                                                            </div>
                                                            <b className="p-1">{(tblprofile != null) ? tblprofile.Cashtotal : 0}</b>
                                                        </div>
                                                        <div className="text-left"> คืนยอดเสีย {(cashoutSet != null) ? cashoutSet.percent : 0}% </div>
                                                        <div
                                                            data-v-00ef951c=""
                                                            className="auction-pool-menu-commission mt-2 mb-2"
                                                        >
                                                            <div className="p-4 text-center">
                                                                <label htmlFor="" className="">
                                                                    <h5>คืนยอดเสียของคุณ</h5>
                                                                </label>
                                                                <h5 className="text-danger">        <b className="font-aff-wid">{(tblprofile != null) ? tblprofile.Cashtotal : 0}</b></h5>
                                                            </div>
                                                        </div>
                                                        <div className="text-color">ยอดเริ่มต้น 1 บาท</div>
                                                        <div data-v-00ef951c="" className="auction-pool-menu">
                                                            <div className="font-income">
                                                                <div className="mt-2 mb-2">
                                                                    <a
                                                                        onClick={(e) => {
                                                                            this.opencliamcashout(e, 'bonusrankaccount')
                                                                        }}
                                                                        className="btn -submit js-submit-accept-term v-login mt-lg-1 mt-0 w-100 p-2">
                                                                        <span> เเจ้งถอนรายได้ </span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-2 text-left mt-4 mb-1 animated animatedFadeInUp fadeInUp text-color">
                                                {" "}
                                                ประวัติการทำรายการ{" "}
                                            </div>
                                            <div className="animated animatedFadeInUp fadeInUp">
                                                <div>
                                                    <div>
                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                            <b>
                                                                <img
                                                                    className="load-history"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                    alt=""
                                                                />
                                                                <div className="not-history font-history-menu-text p-2">
                                                                    <small>
                                                                        <b>ไม่พบข้อมูล</b>
                                                                    </small>
                                                                </div>
                                                            </b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 mt-2" style={{ display: tabselect == 7 ? "" : "none" }}>
                                        <div className="m-2 border-shadow-title animated animatedFadeInUp fadeInUp">
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction top-loss animated animatedFadeInUp fadeInUp"
                                                role="button"
                                            >
                                                <div
                                                    data-v-ab1d19ba=""
                                                    className="auction__body-menu auction__body--border-radius"
                                                >
                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                        <h3 className="x-title-modal mx-auto text-center">
                                                            <b>คูปอง</b>
                                                        </h3>
                                                        <hr />
                                                        <div className="mb-1">
                                                            <label htmlFor="price" className="mt-1 mb-1 text-left">
                                                                กรอกโค้ดโปรโมชั่น
                                                            </label>
                                                            <div className="-x-input-icon flex-column">
                                                                <div className="input-group mb-1">
                                                                    <input
                                                                        type="text"
                                                                        className="bg-border-input form-control form-control-form form-not-input-login-register"
                                                                        placeholder=""
                                                                        aria-label={0}
                                                                        aria-describedby="basic-addon1"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-2 mb-2">
                                                            {/**/}
                                                            <div>
                                                                <div>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            this.couponredeem(e)
                                                                        }}
                                                                        type="submit"
                                                                        className="btn -submit js-submit-accept-term v-login mt-0 w-100 p-2 mb-4"
                                                                    >
                                                                        ยืนยัน
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-2 mb-4">
                                                            <label htmlFor="price" className="mb-1 text-left">
                                                                โปรโมชั่นทั้งหมด
                                                            </label>
                                                            <div className="text-left">
                                                                <small>
                                                                    <b>หมายเหตุ :</b>: "
                                                                    เพียงฝากให้ยอดตรงกับเงื่อนไขโปรโมชั่นท่านจะได้รับโปรโมชั่นอัตโนมัติทันที{" "}
                                                                    {/**/}"{" "}
                                                                </small>
                                                            </div>
                                                            <div className="p-1">
                                                                <div className="row">
                                                                    {prolistx.map(prolists => (
                                                                        <div className="text-center mb-4 col-12 col-lg-4">
                                                                            <a
                                                                                href="#0"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={(e) => this.checkpro(e, prolists.no)}
                                                                            >
                                                                                <div
                                                                                    className="p-1 bg-mission-button example"
                                                                                >
                                                                                    <img
                                                                                        className="w-100"
                                                                                        data-action="zoom"
                                                                                        src={prolists.linkpicture}
                                                                                        alt={prolists.linkpicture}
                                                                                        style={{ borderRadius: 13 }}
                                                                                    />
                                                                                    <div className="text position-auto-text">
                                                                                        {prolists.proname}
                                                                                    </div>
                                                                                </div>
                                                                            </a>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 8 ? "" : "none" }}>
                                        <div className="animated animatedFadeInUp fadeInUp">
                                            <div className="js-profile-account-modal -layout-account">
                                                <div className="x-account-profile -v2">
                                                    <div
                                                        data-animatable="fadeInModal"
                                                        className="-profile-container animated fadeInModal"
                                                    >
                                                        <h3 className="x-title-modal mx-auto text-center">
                                                            <b>ข้อมูลบัญชี</b>
                                                        </h3>
                                                        <div className="animated animatedFadeInUp fadeInUp p-2" style={{ display: tabselect == 8 && this.state.resetpass == 0 ? "" : "none" }}>
                                                            <div className="text-center">
                                                                <div className="my-3">
                                                                    <div className="x-profile-image">
                                                                        <img
                                                                            className="img-fluid -profile-image"
                                                                            src={"/build/rank/" + this.state.rankpic}
                                                                            // src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                                                            alt="customer image"
                                                                        />{" "}
                                                                        {username}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="collapse -change-password-container js-change-password-collapse"
                                                                >
                                                                    <div className="js-collapse-content" />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="text-white text-center col mx-auto my-auto">
                                                                    <div className="box-content p-1 p-sm-1">
                                                                        <div className="flex justify-between mb-1 mx-auto">
                                                                            <div className="sub-content w-100 p-3">
                                                                                <div className="text-center">
                                                                                    <img
                                                                                        className="rounded-full w-10 mb-2 flex"
                                                                                        src={accnumber !== null && accnumber !== undefined ? accnumberx.img_path : ""}
                                                                                        style={{ width: 38 }}
                                                                                    />{" "}
                                                                                    &nbsp; {accnumber !== null && accnumber !== undefined ? accnumberx.fullname_th : ""}
                                                                                </div>
                                                                                <div className="text-center">
                                                                                    {firstname} &nbsp; | &nbsp;
                                                                                    {accnumber !== null && accnumber !== undefined ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="x-admin-contact text-center">
                                                                <a
                                                                    onClick={(e) => this.setState({
                                                                        resetpass: 1,
                                                                    })
                                                                    }
                                                                    role="button"
                                                                    className="-link-change-password"
                                                                    data-toggle="collapse"
                                                                    data-target=".js-change-password-collapse"
                                                                >
                                                                    <u>เปลี่ยนรหัสผ่าน</u>
                                                                </a>
                                                                <br />
                                                                <span className="x-text-with-link-component">
                                                                    <label className="-text-message">พบปัญหา</label>
                                                                    <a
                                                                        href={this.state.linelink}
                                                                        role="button"
                                                                        className="-link-message"
                                                                        target="_blank"
                                                                        rel="noopener"
                                                                    >
                                                                        <u>ติดต่อฝ่ายบริการลูกค้า</u>
                                                                    </a>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="text-right animated animatedFadeInUp fadeInUp p-2" style={{ display: tabselect == 8 && this.state.resetpass == 1 ? "" : "none" }}>
                                                            <div className="x-login-index animated animatedFadeInUp fadeInUp p-2">
                                                                <div className="container p-0">
                                                                    <div className="animated animatedFadeInUp fadeInUp mt-2 mb-5-profile text-white" data-v-c2788d34>
                                                                        <div className="row m-0">
                                                                            <div onClick={(e) => this.setState({
                                                                                resetpass: 0,
                                                                            })
                                                                            } className="col-6 text-left" style={{ textAlign: 'left' }}><small className="mt-4 mb-2" role="button"
                                                                                data-v-c2788d34><b data-v-c2788d34><svg xmlns="http://www.w3.org/2000/svg" width={20} height={20}
                                                                                    fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                                                                    <path fillRule="evenodd"
                                                                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                                                                                </svg> กลับ </b></small></div>
                                                                            <div className="col-6" style={{ textAlign: 'right' }}><small className="mt-4 mb-2" data-v-c2788d34><b
                                                                                data-v-c2788d34> เปลี่ยนรหัสผ่าน </b></small></div>
                                                                            <div className="col-12">
                                                                                <div className="login-modal text-left" style={{ textAlign: 'left' }}>
                                                                                    <div className="mx-0 lg:mx-5 text-white">
                                                                                        <div className="label mt-2"><label htmlFor="password">รหัสผ่านเดิม</label></div>
                                                                                        <div className="input-group mb-3" data-v-8cd0ec04><span
                                                                                            className="input-group-text input-group-circle-left" data-v-8cd0ec04><svg
                                                                                                xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="currentColor"
                                                                                                className="bi bi-key" viewBox="0 0 16 16">
                                                                                                <path
                                                                                                    d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z" />
                                                                                                <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                                                                            </svg></span>
                                                                                            <input onChange={this.onChangex}
                                                                                                id="oldpassword"
                                                                                                name="oldpassword"
                                                                                                type={this.state.showpassold ? "text" : "password"}
                                                                                                required="required"
                                                                                                placeholder="กรุณารหัสผ่าน"
                                                                                                autoFocus="autoFocus"
                                                                                                autoComplete="on"
                                                                                                inputMode="text"
                                                                                                className="form-control input-group-text"
                                                                                                aria-label="รหัสผ่าน" aria-describedby="basic-addon1" /><span

                                                                                                    onClick={(e) => {
                                                                                                        this.onChangexxxxx(1)
                                                                                                    }}
                                                                                                    className="input-group-text input-group-circle-right" id="change-eye" role="button"><svg
                                                                                                        xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor"
                                                                                                        className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                                                    <path
                                                                                                        d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                    <path
                                                                                                        d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                    <path
                                                                                                        d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                </svg></span></div>
                                                                                        <div className="label mt-6"><label htmlFor="password">รหัสผ่านใหม่</label></div>
                                                                                        <div className="input-group mb-3" data-v-8cd0ec04><span

                                                                                            className="input-group-text input-group-circle-left" data-v-8cd0ec04><svg
                                                                                                xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="currentColor"
                                                                                                className="bi bi-shield-lock-fill" viewBox="0 0 16 16">
                                                                                                <path fillRule="evenodd"
                                                                                                    d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z" />
                                                                                            </svg></span><input onChange={this.onChangex}
                                                                                                type={this.state.showpassnew ? "text" : "password"}
                                                                                                id="password"
                                                                                                name="password"
                                                                                                required="required"
                                                                                                placeholder="กรุณารหัสผ่าน"
                                                                                                autoFocus="autoFocus"
                                                                                                autoComplete="on"
                                                                                                inputMode="text"
                                                                                                className="form-control input-group-text"
                                                                                                aria-label="รหัสผ่านใหม่" aria-describedby="basic-addon1" /><span
                                                                                                    onClick={(e) => {
                                                                                                        this.onChangexxxxx(2)
                                                                                                    }}
                                                                                                    className="input-group-text input-group-circle-right" id="change-eye" role="button"><svg
                                                                                                        xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor"
                                                                                                        className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                                                    <path
                                                                                                        d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                    <path
                                                                                                        d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                    <path
                                                                                                        d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                </svg></span></div>
                                                                                        <div className="label mt-6"><label htmlFor="password">ยืนยันรหัสผ่าน</label></div>
                                                                                        <div
                                                                                            className="input-group mb-3" data-v-8cd0ec04><span

                                                                                                className="input-group-text input-group-circle-left" data-v-8cd0ec04><svg
                                                                                                    xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="currentColor"
                                                                                                    className="bi bi-shield-lock-fill" viewBox="0 0 16 16">
                                                                                                    <path fillRule="evenodd"
                                                                                                        d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z" />
                                                                                                </svg></span><input
                                                                                                onChange={this.onChangex}
                                                                                                type={this.state.showpasscf ? "text" : "password"}
                                                                                                id="passwordcf"
                                                                                                name="passwordcf"
                                                                                                required="required"
                                                                                                placeholder="กรุณารหัสผ่าน"
                                                                                                autoFocus="autoFocus"
                                                                                                autoComplete="on"
                                                                                                inputMode="text"
                                                                                                aria-label="รหัสผ่าน"
                                                                                                className="form-control input-group-text"
                                                                                                aria-describedby="basic-addon1" /><span
                                                                                                    onClick={(e) => {
                                                                                                        this.onChangexxxxx(3)
                                                                                                    }}
                                                                                                    className="input-group-text input-group-circle-right" id="change-eye" role="button"><svg
                                                                                                        xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor"
                                                                                                        className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                                                    <path
                                                                                                        d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                    <path
                                                                                                        d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                    <path
                                                                                                        d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                </svg></span></div><button
                                                                                                    onClick={(e) => {
                                                                                                        this.resetpassword(e, 1)
                                                                                                    }}


                                                                                                    className="btn box-shadow-danger js-submit-accept-term v-login mt-lg-1 mt-0 w-100 p-3"><span>ยืนยัน
                                                                                            </span></button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 10 ? "" : "none" }}>
                                        {tabselect == 10 && (
                                            <Casino
                                                userid={this.state.username}
                                                loginstate={this.state.loginstate}
                                                onNavigate={(to, e) => {
                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }} />
                                        )}
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 11 ? "" : "none" }}>
                                        {tabselect == 11 && (
                                            <GameHit userid={this.state.username}
                                                loginstate={this.state.loginstate}
                                                onNavigate={(to, e) => {

                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }} />
                                        )}
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 12 ? "" : "none" }}>
                                        {tabselect == 12 && (
                                            <Fishing userid={this.state.username}
                                                loginstate={this.state.loginstate} onNavigate={(to, e) => {

                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 13 ? "" : "none" }}>
                                        {tabselect == 13 && (
                                            <Slot userid={this.state.username}
                                                loginstate={this.state.loginstate}
                                                onNavigate={(to, e) => {

                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }} />
                                        )}
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 14 ? "" : "none" }}>
                                        {tabselect == 14 && (
                                            <Sport userid={this.state.username}
                                                loginstate={this.state.loginstate}
                                                onNavigate={(to, e) => {

                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }} />
                                        )}
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 15 ? "" : "none" }}>
                                        {tabselect == 15 && (
                                            <Listgameall
                                                userid={this.state.username}
                                                loginstate={this.state.loginstate}
                                                onNavigate={(to, e) => {

                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }} />
                                        )}
                                    </div>
                                    <div className="x-margin-top-v3 pt-3 m-2" style={{ display: tabselect == 17 ? "" : "none" }}>
                                        {tabselect == 17 && (
                                            <Lotto userid={this.state.username}
                                                loginstate={this.state.loginstate} onNavigate={(to, e) => {

                                                    if (e?.preventDefault) e.preventDefault();
                                                    window.history.pushState(null, "", to);
                                                    // เรียกฟังก์ชันกลางของคุณ
                                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                                }}
                                            />
                                        )}
                                    </div>

                                    <div className="container p-0 mt-3" style={{ display: tabselect == 16 ? "" : "none" }}>
                                        <div className="m-0 border-shadow-title animated animatedFadeInUp fadeInUp">
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction top-loss animated animatedFadeInUp fadeInUp"
                                                role="button"
                                            >
                                                <div
                                                    data-v-ab1d19ba=""
                                                    className="auction__body-menu auction__body--border-radius"
                                                >
                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                        <div className="row m-0">
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 4)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5b484701-23cf-4a1e-a37b-251dd801a000/public"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 5)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d19594c3-f5b7-4544-ce8c-b923b8f13200/public"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 7)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/907ff1f1-3e6d-4cfc-c89b-1cd216488900/public"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 36)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://cdn.javisx.com/image/c3b15c70-254b-43c5-ad93-70c84f1d9bf4.png"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 37)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/26f16614-9ab8-4ea3-9613-b5ff90f3d300/public"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 35)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://cdn.javisx.com/image/a44237d0-ad22-4432-846c-06a4bcad8d13.png"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 text-center p-1">
                                                                <div className="p-1 bg-mission-button example">
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 5)
                                                                    }}
                                                                    >
                                                                        <img
                                                                            className="w-100 img-hover-event"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/c62a09a8-29aa-4e8d-b6dd-438e1de04500/public"
                                                                            alt=""
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3" style={{ display: tabselect == 200 ? "" : "none" }}>
                                        <div className="x-login-index animated animatedFadeInUp fadeInUp p-2">
                                            <div>
                                                <div>
                                                    <div className="-inner-wrapper text-left">
                                                        <div className="bg-game-list mt-2 text-white">
                                                            <div className="d-flex justify-content-between p-2">
                                                                <div>
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 1)
                                                                    }}>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={16}
                                                                            height={16}
                                                                            fill="currentColor"
                                                                            className="bi bi-arrow-left-circle"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                fillRule="evenodd"
                                                                                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                                                                            />
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                                <div />
                                                                <div>
                                                                    <small>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={20}
                                                                            height={20}
                                                                            fill="currentColor"
                                                                            className="bi bi-controller"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M11.5 6.027a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm-6.5-3h1v1h1v1h-1v1h-1v-1h-1v-1h1v-1z" />
                                                                            <path d="M3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .62.39c.655-.079 1.35-.117 2.043-.117.72 0 1.443.041 2.12.126a.5.5 0 0 1 .622-.399l1.932.518a.5.5 0 0 1 .306.729c.14.09.266.19.373.297.408.408.78 1.05 1.095 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.816-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773-.245-.232-.496-.526-.739-.808-.126-.148-.25-.292-.368-.423-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.423-.243.282-.494.575-.739.808-.398.38-.877.706-1.513.773a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772a2.34 2.34 0 0 1 .433-.335.504.504 0 0 1-.028-.079zm2.036.412c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.504C4.861 9.969 5.978 9.027 8 9.027s3.139.942 3.965 1.855c.164.181.307.348.44.504.214.251.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z" />
                                                                        </svg>
                                                                        <label htmlFor="">&nbsp;ประเภท&nbsp;: ธนาคาร</label>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mt-3">
                                                        <div className="x-login-index animated animatedFadeInUp fadeInUp p-2 text-white">
                                                            <div>
                                                                <h6 className="mt-1 text-center text-white">
                                                                    <u>บัญชีของคุณ</u>
                                                                </h6>
                                                                <div>
                                                                    <div>
                                                                        <div className="box-content p-1 p-sm-1">
                                                                            <div className="flex justify-between mb-1 mx-auto">
                                                                                <div className="sub-content w-100 p-3">
                                                                                    <div className="text-center">
                                                                                        <img
                                                                                            className="rounded-full w-10 mb-2 flex"
                                                                                            src={accnumber !== null && accnumber !== undefined ? accnumberx.img_path : ""}
                                                                                            style={{ width: 38 }}
                                                                                        />{" "}
                                                                                        &nbsp; {accnumber !== null && accnumber !== undefined ? accnumberx.fullname_th : ""}
                                                                                    </div>
                                                                                    <div className="text-center">
                                                                                        {firstname} &nbsp; | &nbsp;
                                                                                        {accnumber !== null && accnumber !== undefined ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className="text-white text-center">
                                                                        <h6 className="mb-2 mt-2 text-center">
                                                                            <u>โอนเข้าบัญชี</u>
                                                                        </h6>
                                                                        <div>
                                                                            {mainacc !== null && mainacc !== undefined && mainacc !== '' && mainacc.length > 0 ?
                                                                                <div className="flex justify-between mb-1 mx-auto box-content">
                                                                                    <div className="sub-content w-100 p-3 px-lg-5">
                                                                                        <div className="text-center">
                                                                                            <img
                                                                                                className="rounded-full w-10 mb-2 flex"
                                                                                                src={mainacc[0].img_path}
                                                                                                style={{ width: 38 }}
                                                                                            />{" "}
                                                                                            &nbsp;{mainacc[0].fullname_th}
                                                                                        </div>
                                                                                        <div className="text-center">
                                                                                            {mainacc[0].first_name_en + " " + mainacc[0].last_name_en} :&nbsp; {
                                                                                                mainacc[0].accnumber.substring(0, 3) + "-" + mainacc[0].accnumber.substring(3, 9) + "-" + mainacc[0].accnumber.substring(9, 12)
                                                                                            }
                                                                                        </div>
                                                                                        <div className="text-center pt-2">
                                                                                            <div
                                                                                                className="btn v-login"
                                                                                                style={{ fontSize: 16, cursor: "pointer" }}
                                                                                            >
                                                                                                {" "}
                                                                                                เลขบัญชี :&nbsp;{" "}
                                                                                                <span id="copy-banktransfer">
                                                                                                    {mainacc[0].accnumber}
                                                                                                </span>{" "}
                                                                                                &nbsp;&nbsp;
                                                                                                <a onClick={(e) => this.copy(e, mainacc[0].accnumber)}>
                                                                                                    <span
                                                                                                        className="badge text-bg-white p-1"
                                                                                                        style={{ borderRadius: "33.9916px" }}
                                                                                                    >
                                                                                                        &nbsp; คัดลอก &nbsp;
                                                                                                    </span>
                                                                                                </a>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                : ""}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className="text-white text-center">
                                                                        <div className="box-content p-0">
                                                                            <div className="sub-content p-3">
                                                                                <div className="d-flex justify-content-between">
                                                                                    <div className="text-white pt-1">
                                                                                        <img
                                                                                            src="https://cdn.javisx.com/image/7fa5a9e6-184d-4282-be20-76707d721f05.png"
                                                                                            alt=""
                                                                                            style={{ width: 30 }}
                                                                                        />{" "}
                                                                                        &nbsp; รับโปรโมชั่นอัตโนมัติ{" "}
                                                                                    </div>
                                                                                    <div className="text-white">
                                                                                        <div className="form-check form-switch">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                role="switch"
                                                                                                id="flexSwitchCheckDefault"
                                                                                                style={{ width: "6em", padding: 12 }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <br />
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        </div>
                                        <div
                                            className="modal fade"
                                            id="popup-promotion"
                                            tabIndex={-1}
                                            aria-labelledby="popup-promotion-Label"
                                            aria-hidden="true"
                                            style={{ padding: 20 }}
                                        >
                                            <div className="modal-dialog modal-dialog-centered text-white">
                                                <div
                                                    className="modal-content bg-popup-promotion"
                                                    style={{ borderRadius: "15px !important" }}
                                                >
                                                    <div className="mt-3">
                                                        <h1
                                                            className="modal-title fs-5 text-center"
                                                            id="popup-promotion-Label"
                                                        >
                                                            ต้องการรับโปรโมชั่น
                                                        </h1>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="text-center row">
                                                            <div className="col-6 text-right">
                                                                <button
                                                                    type="button"
                                                                    className="p-1 btn btn-danger w-100"
                                                                    data-bs-dismiss="modal"
                                                                >
                                                                    {" "}
                                                                    ไม่รับโปรฯ{" "}
                                                                </button>
                                                            </div>
                                                            <div className="col-6 text-left">
                                                                <button
                                                                    type="button"
                                                                    data-bs-dismiss="modal"
                                                                    className="p-1 btn btn-success text-white w-100"
                                                                >
                                                                    {" "}
                                                                    รับโปรฯ{" "}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-gift-fill"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7h6zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9H2.5z" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            <div className="col-12 text-left mt-2">
                                                                <small className="text-danger">
                                                                    * สามารถเปลี่ยนสถานะภายหลังได้
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3" style={{ display: tabselect == 210 ? "" : "none" }}>
                                        <div className="x-login-index animated animatedFadeInUp fadeInUp p-2">
                                            <div>
                                                <div>
                                                    <div className="-inner-wrapper text-left">
                                                        <div className="bg-game-list mt-2 text-white">
                                                            <div className="d-flex justify-content-between p-2">
                                                                <div>
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 1)
                                                                    }}>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={16}
                                                                            height={16}
                                                                            fill="currentColor"
                                                                            className="bi bi-arrow-left-circle"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                fillRule="evenodd"
                                                                                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                                                                            />
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                                <div />
                                                                <div>
                                                                    <small>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={20}
                                                                            height={20}
                                                                            fill="currentColor"
                                                                            className="bi bi-controller"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M11.5 6.027a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm-6.5-3h1v1h1v1h-1v1h-1v-1h-1v-1h1v-1z" />
                                                                            <path d="M3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .62.39c.655-.079 1.35-.117 2.043-.117.72 0 1.443.041 2.12.126a.5.5 0 0 1 .622-.399l1.932.518a.5.5 0 0 1 .306.729c.14.09.266.19.373.297.408.408.78 1.05 1.095 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.816-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773-.245-.232-.496-.526-.739-.808-.126-.148-.25-.292-.368-.423-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.423-.243.282-.494.575-.739.808-.398.38-.877.706-1.513.773a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772a2.34 2.34 0 0 1 .433-.335.504.504 0 0 1-.028-.079zm2.036.412c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.504C4.861 9.969 5.978 9.027 8 9.027s3.139.942 3.965 1.855c.164.181.307.348.44.504.214.251.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z" />
                                                                        </svg>
                                                                        <label htmlFor="">&nbsp;ประเภท&nbsp;: ทรูมันนี่</label>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    {trueaccount !== null ?
                                                        <div className="text-white-v1-deposit text-center">
                                                            <h6 className="mb-2 mt-2 text-center">
                                                                <u>โอนเข้าบัญชี</u>
                                                            </h6>
                                                            <div>
                                                                <div className="flex justify-between mb-1 mx-auto box-content">
                                                                    <div className="sub-content w-100 p-3 px-lg-5">
                                                                        <div className="text-center">
                                                                            <img
                                                                                className="rounded-full w-10 mb-2 flex"
                                                                                src="https://play-lh.googleusercontent.com/6I2IYbIg4rhGUgs0UxP_5q6wmJmlBjBrlQ9f0_FAN94yOzwmrtEteifCdPPd1-chY_NX"
                                                                                style={{ width: 38 }}
                                                                            />{" "}
                                                                            &nbsp;วอลเลท
                                                                        </div>
                                                                        <div className="text-center">
                                                                            {trueaccount.name} :&nbsp; {
                                                                                trueaccount.telnumber
                                                                            }
                                                                        </div>
                                                                        <div className="text-center pt-2">
                                                                            <a href={() => false} style={{ cursor: "pointer" }}
                                                                                onClick={() => navigator.clipboard.writeText(trueaccount.telnumber)}>
                                                                                <div
                                                                                    className="btn v-login"
                                                                                    style={{
                                                                                        fontSize: 16,
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                >
                                                                                    วอลเลท :&nbsp;{" "}
                                                                                    <span id="copy-banktransfer">
                                                                                        {trueaccount.telnumber}
                                                                                    </span>{" "}
                                                                                    &nbsp;&nbsp;
                                                                                    <span
                                                                                        className="badge text-bg-white p-1"
                                                                                        style={{
                                                                                            borderRadius: "33.9916px"
                                                                                        }}
                                                                                    >
                                                                                        &nbsp; คัดลอก &nbsp;
                                                                                    </span>
                                                                                </div>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> :
                                                        <div className="text-center text-white bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                            <img
                                                                className="load-history"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                alt=""
                                                            />
                                                            <div className="not-history font-history-menu-text p-2">
                                                                <small>
                                                                    <b>ยังไม่ให้บริการ</b>
                                                                </small>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                        </div>
                                        <div
                                            className="modal fade"
                                            id="popup-promotion"
                                            tabIndex={-1}
                                            aria-labelledby="popup-promotion-Label"
                                            aria-hidden="true"
                                            style={{ padding: 20 }}
                                        >
                                            <div className="modal-dialog modal-dialog-centered text-white">
                                                <div
                                                    className="modal-content bg-popup-promotion"
                                                    style={{ borderRadius: "15px !important" }}
                                                >
                                                    <div className="mt-3">
                                                        <h1
                                                            className="modal-title fs-5 text-center"
                                                            id="popup-promotion-Label"
                                                        >
                                                            {" "}
                                                            รับโปรโมชั่นอัตโนมัติ{" "}
                                                        </h1>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="text-center row">
                                                            <div className="col-6 text-right">
                                                                <button
                                                                    type="button"
                                                                    className="p-1 btn btn-danger w-100"
                                                                    data-bs-dismiss="modal"
                                                                >
                                                                    {" "}
                                                                    ไม่รับโปรฯ{" "}
                                                                </button>
                                                            </div>
                                                            <div className="col-6 text-left">
                                                                <button
                                                                    type="button"
                                                                    data-bs-dismiss="modal"
                                                                    className="p-1 btn btn-success text-white w-100"
                                                                >
                                                                    {" "}
                                                                    รับโปรฯ{" "}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-gift-fill"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7h6zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9H2.5z" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            <div className="col-12 text-left mt-2">
                                                                <small className="text-danger">
                                                                    * สามารถเปลี่ยนสถานะภายหลังได้
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-12" style={{ display: tabselect == 220 ? "" : "none" }}>
                                        <div className="row m-0 border-shadow-title">
                                            <div className="col-12 p-0  mx-auto my-auto text-white-deposit">
                                                <div className="mt-2 mb-2 text-center bg-title-web">
                                                    <div>
                                                        <div className="text-title text-white text-center">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="text-white-deposit">
                                                                    <a role="button" href='/'>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={16}
                                                                            height={16}
                                                                            fill="currentColor"
                                                                            className="bi bi-house-door"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146ZM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5Z" />
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                                <div className="text-white-deposit">
                                                                    <h4> สเเกน QR ฝากเงิน </h4>
                                                                </div>
                                                                <div />
                                                            </div>
                                                            <hr className="mt-0" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-3 text-white-deposit">
                                                    <div className="animated animatedFadeInUp fadeInUp">
                                                        <div className="card-promptpay text-center text-white-deposit" style={{ display: this.state.qrcodecheck ? "none" : "" }}>
                                                            <img
                                                                className="img-logo-promptpay"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9c9ef88c-a34b-4aa6-1a42-54ff6cd9a800/public"
                                                                alt=""
                                                            />
                                                            <span className="text-white-deposit">
                                                                {" "}
                                                                พร้อมเพย์ / ทรูมันนี่วอลเล็ท{" "}
                                                            </span>
                                                            <div className="pt-3 pb-2 text-left p-detail-promptpay">
                                                                <div className="pt-2 pb-2">
                                                                    <small className="text-white-deposit p">
                                                                        {" "}
                                                                        ระบุจำนวนเงินที่ต้องเติม{" "}
                                                                    </small>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    placeholder="กรอกจำนวนเงิน"
                                                                    id="deposit_amount"
                                                                    onChange={this.onChange}
                                                                    name="depositamount"
                                                                    value={this.state.depositamount}
                                                                    maxLength={4}
                                                                    minLength={4}
                                                                    className="form-control promptpay-border-radius"
                                                                />
                                                                <div className="mb-1 mt-2">
                                                                    <label htmlFor="price" className="mt-1 mb-1 text-left">
                                                                        เลือกจำนวน
                                                                    </label>
                                                                    <div className="mb-4 row m-0">
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 100)}>

                                                                                    100

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 300)}>
                                                                                    300
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 500)}>
                                                                                    500
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 1000)}>

                                                                                    1,000
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 3000)}>

                                                                                    3,000
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 5000)}>

                                                                                    5,000

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 10000)}>

                                                                                    10,000

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 30000)}>
                                                                                    30,000
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-4 px-1">
                                                                            <div className="card-amount-qr mt-2 text-white-deposit">
                                                                                <div className="text-white-deposit" onClick={(e) => this.handleClickreposit(e, 50000)}>
                                                                                    50,000
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="pt-2 pb-2">
                                                                    <button onClick={(e) => this.confirmdeposit(e, 0, 1)} className="btn btn-primary w-100 text-white">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={16}
                                                                            height={16}
                                                                            fill="currentColor"
                                                                            className="bi bi-check-circle-fill"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                                        </svg>{" "}
                                                                        สร้าง QR Code เพื่อชำระ{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-promptpay text-center pt-3" style={{ display: this.state.qrcodecheck ? "" : "none" }}>
                                                            <div className="card-body-promptpay">
                                                                <div className="card card-2-promptpay">
                                                                    <div className="card-header card-2-promptpay-header">
                                                                        {" "}
                                                                        สำหรับชำระเงิน
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <div className="p-2 mb-2 bg-success-subtle">
                                                                            <small className="text text-danger w-100">
                                                                                ต้องโอนให้ตรงกับที่ระบุ เท่านั้น
                                                                            </small>
                                                                        </div>
                                                                        <div className="prt-2">
                                                                            <div className="img-qr-code">

                                                                                {paymentlist !== null && paymentlist !== undefined && paymentlist !== '' ? (
                                                                                    <>
                                                                                        <div className="text-white-v1-deposit text-center" style={{ display: paymentlist?.paymentMethod == "bankTransfer" ? "" : "none" }}>
                                                                                            <h6 className="mb-2 mt-2 text-center" >
                                                                                                <u>โอนเข้าบัญชี</u>
                                                                                            </h6>
                                                                                            <div>
                                                                                                <div className="flex justify-between mb-1 mx-auto box-content" >
                                                                                                    <div className="sub-content w-100 p-3 px-lg-5">
                                                                                                        <div className="text-center">
                                                                                                            {menuItems.map((item, index) =>
                                                                                                                item.bank === (paymentlist?.bank_name?.toString() || "") ? (
                                                                                                                    <img
                                                                                                                        key={index}
                                                                                                                        className="rounded-full w-10 mb-2 flex"
                                                                                                                        src={item.imgSrc}
                                                                                                                        style={{ width: 38 }}
                                                                                                                    />
                                                                                                                ) : null
                                                                                                            )}
                                                                                                            {" "} {paymentlist?.bank_name || ""}
                                                                                                        </div>

                                                                                                        <div className="text-center">
                                                                                                            {paymentlist?.account_name || ""} :&nbsp;
                                                                                                            {paymentlist?.account_no
                                                                                                                ? `${paymentlist.account_no.substring(0, 3)}-${paymentlist.account_no.substring(3, 9)}-${paymentlist.account_no.substring(9, 12)}`
                                                                                                                : ""}
                                                                                                        </div>
                                                                                                        <br></br>
                                                                                                        <small className="text w-100">
                                                                                                            Orderid : {paymentlist?.uuid || ""}
                                                                                                        </small>
                                                                                                        <div className="text-center pt-2">
                                                                                                            <a
                                                                                                                href={() => false}
                                                                                                                style={{ cursor: "pointer" }}
                                                                                                                onClick={() => paymentlist?.account_no && navigator.clipboard.writeText(paymentlist.account_no)}
                                                                                                            >
                                                                                                                <div
                                                                                                                    className="btn v-login"
                                                                                                                    style={{ fontSize: 16, cursor: "pointer" }}
                                                                                                                >
                                                                                                                    ธนาคาร :&nbsp;
                                                                                                                    <span id="copy-banktransfer">
                                                                                                                        {paymentlist?.account_no || ""}
                                                                                                                    </span>
                                                                                                                    &nbsp;&nbsp;
                                                                                                                    <span
                                                                                                                        className="badge text-bg-white p-1"
                                                                                                                        style={{ borderRadius: "33.9916px" }}
                                                                                                                    >
                                                                                                                        &nbsp; คัดลอก &nbsp;
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </a>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="qtx-number pt-2">
                                                                                                <h5 className="font-qtx-number">
                                                                                                    <b>
                                                                                                        {this.state.depositamount}{" "}
                                                                                                        <span>
                                                                                                            <img
                                                                                                                className="lang-type-bath"
                                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d729c93e-e40d-4c6f-db8b-be26f954d200/public"
                                                                                                                alt=""
                                                                                                            />
                                                                                                        </span>
                                                                                                    </b>
                                                                                                </h5>
                                                                                            </div>
                                                                                            <hr className="m-1" />
                                                                                            <div className="qtx-date-time">
                                                                                                <h5 className="font-qtx-date-time m-0">
                                                                                                    <b>{this.state.counter > 0 ? this.state.counter + " วินาที" : ""} </b>
                                                                                                </h5>
                                                                                                <h5 className="text-danger remark-date-time m-0">
                                                                                                    โปรดชำระเงินภายในเวลาที่กำหนด
                                                                                                </h5>
                                                                                            </div>
                                                                                            <hr className="m-1" />
                                                                                            <div className="bg-success-subtle p-2 mb-2 text-color-details">
                                                                                                <div className="font-details-qr-code">
                                                                                                    {" "}
                                                                                                    หากเกิดปัญหาฝากเงินหรืออื่นๆ
                                                                                                    กรุณาติดต่อเจ้าหน้าที่{" "}
                                                                                                    <b className="text-danger">
                                                                                                        <a role="button">
                                                                                                            Line ID : {this.state.linelink}
                                                                                                        </a>
                                                                                                    </b>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="text-white-v1-deposit text-center" style={{ display: paymentlist?.paymentMethod === "qr" ? "" : "none" }}>
                                                                                            <div className="card-body-promptpay">
                                                                                                <div className="card card-2-promptpay">
                                                                                                    <div className="card-header card-2-promptpay-header">
                                                                                                        {" "}
                                                                                                        QR Code สำหรับชำระเงิน
                                                                                                    </div>
                                                                                                    <div className="card-body">
                                                                                                        <div className="p-2 mb-2 bg-success-subtle">
                                                                                                            <small className="text">
                                                                                                                QR Code
                                                                                                                สามารถสเเกนจ่ายได้เพียงครั้งเดี่ยวเท่านั้นโปรดอย่าสเเกนจ่ายซ้ำ
                                                                                                            </small>
                                                                                                        </div>
                                                                                                        <div className="prt-2">
                                                                                                            <div className="img-qr-code">
                                                                                                                {this.state.qrcode !== null ?
                                                                                                                    <img
                                                                                                                        src={this.state.qrcode}
                                                                                                                        className="-img-text-promotion img-fluid ls-is-cached lazyloaded"
                                                                                                                        alt=""
                                                                                                                        style={{ backgroundColor: "black", height: 196, width: 196 }}
                                                                                                                        height={196}
                                                                                                                        width={196}
                                                                                                                    /> : ""
                                                                                                                }
                                                                                                            </div>
                                                                                                            <div className="qtx-number pt-2">
                                                                                                                <h5 className="font-qtx-number">
                                                                                                                    <b>
                                                                                                                        {this.state.depositamount}{" "}
                                                                                                                        <span>
                                                                                                                            <img
                                                                                                                                className="lang-type-bath"
                                                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d729c93e-e40d-4c6f-db8b-be26f954d200/public"
                                                                                                                                alt=""
                                                                                                                            />
                                                                                                                        </span>
                                                                                                                    </b>
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                            <hr className="m-1" />
                                                                                                            <div className="qtx-date-time">
                                                                                                                <h5 className="font-qtx-date-time m-0">
                                                                                                                    <b>{this.state.counter > 0 ? this.state.counter + " วินาที" : ""} </b>
                                                                                                                </h5>
                                                                                                                <h5 className="text-danger remark-date-time m-0">
                                                                                                                    โปรดชำระเงินภายในเวลาที่กำหนด
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                            <hr className="m-1" />
                                                                                                            <div className="bg-success-subtle p-2 mb-2 text-color-details">
                                                                                                                <div className="font-details-qr-code">
                                                                                                                    {" "}
                                                                                                                    หากเกิดปัญหาฝากเงินหรืออื่นๆ
                                                                                                                    กรุณาติดต่อเจ้าหน้าที่{" "}
                                                                                                                    <b className="text-danger">
                                                                                                                        <a role="button">
                                                                                                                            Line ID : {this.state.linelink}
                                                                                                                        </a>
                                                                                                                    </b>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            {/* <a role="button" className="btn btn-danger w-100">
                                                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                                                width={16}
                                                                                                                height={16}
                                                                                                                fill="currentColor"
                                                                                                                className="bi bi-x-circle-fill"
                                                                                                                viewBox="0 0 16 16"
                                                                                                            >
                                                                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                                                                                                            </svg>{" "}
                                                                                                            {this.state.counter > 0 ? "ยกเลิกรายการ" : "กรุณาทำรายการใหม่"}
                                                                                                        </a> */}
                                                                                                            {/**/}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                ) : ""}

                                                                            </div>

                                                                            <a role="button"
                                                                                onClick={async (e) => {
                                                                                    e.preventDefault();

                                                                                    const result = await Swal.fire({
                                                                                        title: 'ยืนยันการทำรายการ?',
                                                                                        text: "คุณแน่ใจหรือไม่ที่จะดำเนินการต่อ",
                                                                                        icon: 'warning',
                                                                                        showCancelButton: true,
                                                                                        confirmButtonText: 'ยืนยัน',
                                                                                        cancelButtonText: 'ยกเลิก',
                                                                                        reverseButtons: true
                                                                                    });

                                                                                    if (result.isConfirmed) {
                                                                                        this.checktab(e, 220);

                                                                                        toast.success("ดำเนินการสำเร็จ", {
                                                                                            position: "top-right",
                                                                                            autoClose: 5000,
                                                                                            hideProgressBar: false,
                                                                                            closeOnClick: true,
                                                                                            pauseOnHover: true,
                                                                                            draggable: true,
                                                                                            progress: undefined,
                                                                                            theme: "colored",
                                                                                        });
                                                                                    }
                                                                                }} className="btn btn-danger w-100">
                                                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                                                    width={16}
                                                                                    height={16}
                                                                                    fill="currentColor"
                                                                                    className="bi bi-x-circle-fill"
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                                                                                </svg>{" "}
                                                                                {this.state.counter > 0 ? "ยกเลิกรายการ" : "กรุณาทำรายการใหม่"}
                                                                            </a>
                                                                            {/**/}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-deposit">
                                                <div className="text-white-deposit text-center">
                                                    <div className="box-content p-0">
                                                        <div className="sub-content p-3">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="text-white-deposit pt-1" >
                                                                    <img
                                                                        src="https://cdn.javisx.com/image/7fa5a9e6-184d-4282-be20-76707d721f05.png"
                                                                        alt=""
                                                                        style={{ width: 30 }}
                                                                    />{" "}
                                                                    &nbsp; รับโปรก่อนเติมเงินเท่านั้น
                                                                </div>
                                                                <div className="text-white-deposit">
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            role="switch"
                                                                            id="flexSwitchCheckDefault"
                                                                            style={{ width: "6em", padding: 12 }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <div className="mt-2 text-white" style={{ display: tabselect == 230 ? "" : "none" }}>
                                        <div className="x-login-index animated animatedFadeInUp fadeInUp p-2">
                                            <div className="container">
                                                <div>
                                                    <div className="-inner-wrapper text-left">
                                                        <div className="bg-game-list mt-2 text-white">
                                                            <div className="d-flex justify-content-between p-2">
                                                                <div>
                                                                    <a onClick={(e) => {
                                                                        this.checktab(e, 1)
                                                                    }}>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={16}
                                                                            height={16}
                                                                            fill="currentColor"
                                                                            className="bi bi-arrow-left-circle"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                fillRule="evenodd"
                                                                                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                                                                            />
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                                <div />
                                                                <div>
                                                                    <small>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={20}
                                                                            height={20}
                                                                            fill="currentColor"
                                                                            className="bi bi-controller"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M11.5 6.027a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm-6.5-3h1v1h1v1h-1v1h-1v-1h-1v-1h1v-1z" />
                                                                            <path d="M3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .62.39c.655-.079 1.35-.117 2.043-.117.72 0 1.443.041 2.12.126a.5.5 0 0 1 .622-.399l1.932.518a.5.5 0 0 1 .306.729c.14.09.266.19.373.297.408.408.78 1.05 1.095 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.816-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773-.245-.232-.496-.526-.739-.808-.126-.148-.25-.292-.368-.423-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.423-.243.282-.494.575-.739.808-.398.38-.877.706-1.513.773a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772a2.34 2.34 0 0 1 .433-.335.504.504 0 0 1-.028-.079zm2.036.412c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.504C4.861 9.969 5.978 9.027 8 9.027s3.139.942 3.965 1.855c.164.181.307.348.44.504.214.251.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z" />
                                                                        </svg>
                                                                        <label htmlFor="">&nbsp;ประเภท&nbsp;: ธนาคาร</label>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>
                                                        <div>
                                                            <div>
                                                                <div className="text-white-v1">
                                                                    <div>
                                                                        <div className="mb-1">
                                                                            <label
                                                                                htmlFor="price"
                                                                                className="mt-1 mb-1 text-left"
                                                                            >
                                                                                จำนวนเงิน
                                                                            </label>
                                                                            <div className="-x-input-icon flex-column">
                                                                                <div className="input-group mb-1">
                                                                                    <input
                                                                                        id="withdraw_amount"
                                                                                        onChange={this.onChange}
                                                                                        name="withdrawamount"
                                                                                        value={this.state.withdrawamount}
                                                                                        className="form-control"
                                                                                        placeholder={0}
                                                                                        aria-label={0}
                                                                                        aria-describedby="basic-addon1"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-1">
                                                                            <label
                                                                                htmlFor="price"
                                                                                className="mt-1 mb-1 text-left"
                                                                            >
                                                                                เลือกจำนวน
                                                                            </label>
                                                                            <div className="mb-4 row m-0">
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 100)}>
                                                                                        <div className="text-white-v1">
                                                                                            100
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 300)}>
                                                                                        <div className="text-white-v1">
                                                                                            300
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 500)}>
                                                                                        <div className="text-white-v1">
                                                                                            500
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 1000)}>
                                                                                        <div className="text-white-v1">
                                                                                            1,000
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 3000)}>
                                                                                        <div className="text-white-v1">
                                                                                            3,000
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 5000)}>
                                                                                        <div className="text-white-v1">
                                                                                            5,000
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 10000)}>
                                                                                        <div className="text-white-v1">
                                                                                            10,000
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 30000)}>
                                                                                        <div className="text-white-v1">
                                                                                            30,000
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4 col-md-4 px-1">
                                                                                    <div className="card-amount mt-2 text-white-v1" onClick={(e) => this.handleClick(e, 50000)}>
                                                                                        <div className="text-white-v1">
                                                                                            50,000
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/**/}
                                                                    <div>
                                                                        <div className="mt-1 mb-4">
                                                                            <div>
                                                                                <button
                                                                                    onClick={(e) => this.submitwithdraw(e)}
                                                                                    className="btn -submit js-submit-accept-term v-login btn-success mt-lg-1 mt-0 w-100 p-2">
                                                                                    ถัดไป
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/**/}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                    <div className="x-margin-top-v3 text-white" style={{ display: tabselect == 24 ? "" : "none" }}>
                                        <div className="animated animatedFadeInUp fadeInUp m-2">
                                            <div className="mt-3">
                                                <h3 className="x-title-modal mx-auto text-center mb-3">
                                                    <b>ภารกิจ</b>
                                                </h3>
                                                <div className="tap-mission p-2">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="w-100">
                                                            <div className="m-1 step-mission-active"> ภารกิจ </div>
                                                        </div>
                                                        <div className="w-100">
                                                            <div className="m-1">ประวัติ</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-2 mb-2">
                                                    <div className="animated animatedFadeInUp fadeInUp">
                                                        <div className="tap-mission-started">
                                                            <div className="d-flex justify-content-between">
                                                                <div
                                                                    className="w-100 started text-center step-started-active"
                                                                    role="button"
                                                                >
                                                                    <div className="w-100-title p-1 text-center">ทั้งหมด</div>
                                                                </div>
                                                                <div className="w-100 started text-center" role="button">
                                                                    <div className="w-100-title p-1 text-center">ฝาก</div>
                                                                </div>
                                                                <div className="w-100 started text-center" role="button">
                                                                    <div className="w-100-title p-1 text-center">เล่นเกม</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-2 mb-2">
                                                            <div className="animated animatedFadeInUp fadeInUp">
                                                                <div>
                                                                    <div>
                                                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                                            <b>
                                                                                <img
                                                                                    className="load-history"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                    alt=""
                                                                                />
                                                                                <div className="not-history font-history-menu-text p-2">
                                                                                    <small>
                                                                                        <b>ไม่พบข้อมูล</b>
                                                                                    </small>
                                                                                </div>
                                                                            </b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <br />
                                                            </div>
                                                            {/**/}
                                                            {/**/}
                                                        </div>
                                                    </div>
                                                    {/**/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 mt-3" style={{ display: tabselect == 25 ? "" : "none" }}>
                                        <div className="m-2 border-shadow-title animated animatedFadeInUp fadeInUp">
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction top-loss animated animatedFadeInUp fadeInUp"
                                                role="button"
                                            >
                                                <div
                                                    data-v-ab1d19ba=""
                                                    className="auction__body-menu auction__body--border-radius"
                                                >
                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                        <h3 className="x-title-modal mx-auto text-center mt-5">
                                                            <b>กิจกรรมเปิดไพ่</b>
                                                        </h3>
                                                        <hr />
                                                        <div>
                                                            <div>
                                                                <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                                    <b>
                                                                        <img
                                                                            className="load-history"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                            alt=""
                                                                        />
                                                                        <div className="not-history font-history-menu-text p-2">
                                                                            <small>
                                                                                <b>ไม่พบข้อมูล</b>
                                                                            </small>
                                                                        </div>
                                                                    </b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 mt-3" style={{ display: tabselect == 26 ? "" : "none" }}>
                                        <div className="m-2 border-shadow-title animated animatedFadeInUp fadeInUp">
                                            <div
                                                data-v-ab1d19ba=""
                                                className="auction top-loss animated animatedFadeInUp fadeInUp"
                                                role="button"
                                            >
                                                <div
                                                    data-v-ab1d19ba=""
                                                    className="auction__body-menu auction__body--border-radius"
                                                >
                                                    <div data-v-ab1d19ba="" className="tab text-color">
                                                        <h3 className="x-title-modal mx-auto text-center mt-5">
                                                            <b>แลกรางวัล</b>
                                                        </h3>
                                                        <hr />
                                                        <div>
                                                            <div>
                                                                <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                                    <b>
                                                                        <img
                                                                            className="load-history"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                            alt=""
                                                                        />
                                                                        <div className="not-history font-history-menu-text p-2">
                                                                            <small>
                                                                                <b>ไม่พบข้อมูล</b>
                                                                            </small>
                                                                        </div>
                                                                    </b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div style={{ display: this.state.tabselect == 0 ? "" : "none" }}>
                                    <div className="row m-1" >
                                        <div class="col-2"></div>
                                        <div className="p-0 text-center animated animatedFadeInUp fadeInUp !w-80 col-8">
                                            <img
                                                role="button"
                                                src={this.state.logoimg}
                                                className="border-home p-1 w-80 img-home-category"
                                                alt=""
                                            />
                                        </div>
                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, '/casino')
                                                // window.location.href = '/casino'
                                            }}
                                            className="p-0 text-center animated animatedFadeInUp fadeInUp col-4 p-1">
                                            <img
                                                role="button"
                                                src="https://cdn.javisx.com/image/f02193b5-6a1e-44ae-a51f-daca1c0ed0b5.jpg"
                                                className="w-100 img-home-category"
                                                alt=""
                                            />
                                        </a>
                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, '/slot')
                                                // window.location.href = '/slot'
                                            }}
                                            className="p-0 text-center animated animatedFadeInUp fadeInUp col-4 p-1">
                                            <img
                                                role="button"
                                                src="https://cdn.javisx.com/image/d3a86181-cc03-49cb-bf79-3aa96b91b81a.jpg"
                                                className="w-100 img-home-category"
                                                alt=""
                                            />
                                        </a>
                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, '/gamehit')
                                                //  window.location.href = '/gamehit'
                                            }}
                                            className="p-0 text-center animated animatedFadeInUp fadeInUp col-4 p-1">
                                            <img
                                                role="button"
                                                src="https://cdn.javisx.com/image/4c4a2ec4-7238-4cc8-a6a7-7c8650920b99.jpg"
                                                className="w-100 img-home-category"
                                                alt=""
                                            />
                                        </a>
                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, '/fishing')
                                                //  window.location.href = '/fishing'
                                            }}
                                            className="p-0 text-center animated animatedFadeInUp fadeInUp col-4 p-1">
                                            <img
                                                role="button"
                                                src="https://cdn.javisx.com/image/5fec4351-47fe-40f1-b587-e3554743a916.jpg"
                                                className="w-100 img-home-category"
                                                alt=""
                                            />
                                        </a>

                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, '/sport')
                                                //  window.location.href = '/sport'
                                            }}
                                            className="p-0 text-center animated animatedFadeInUp fadeInUp col-4 p-1">
                                            <img
                                                role="button"
                                                src="https://cdn.javisx.com/image/30493702-b346-473c-a2f3-9f7b08cc33f3.jpg"
                                                className="w-100 img-home-category"
                                                alt=""
                                            />
                                        </a>
                                        <a
                                            onClick={(e) => {
                                                this.checkurl(e, '/lotto')
                                                //  window.location.href = '/lotto'
                                            }}
                                            className="p-0 text-center animated animatedFadeInUp fadeInUp col-4 p-1">
                                            <img
                                                role="button"
                                                src="https://cdn.javisx.com/image/0145488d-36a2-4ae7-aff1-8d8f6694d994.jpg"
                                                className="w-100 img-home-category"
                                                alt=""
                                            />
                                        </a>
                                    </div>
                                    <div data-v-83acf87c="">
                                        <img
                                            className="w-100 mt-2 mb-2 responsive-line"
                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/1a4467e7-1584-4c78-94f6-39d8d67d8700/public"
                                        />
                                    </div>

                                    <div>
                                        <div className="p-2" data-v-83acf87c="">
                                            <div className="p-1" data-v-83acf87c="">
                                                <div className="row pb-3" data-v-83acf87c="">
                                                    <div className="col-12" data-v-83acf87c="">
                                                        <img
                                                            className="w-100 border-article"
                                                            src="https://cdn.javisx.com/image/5c9aa9eb-a9c6-4a25-b189-63165cebccfc.jpg"
                                                            alt=""
                                                            data-v-83acf87c=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="text-article text-center" data-v-83acf87c="">
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        คาสิโนออนไลน์ switchbet เว็บตรงแหล่งรวมค่าย ครบจบในที่เดียว {" "}
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        ผู้ให้บริการเกมเดิมพันออนไลน์ที่ดีที่สุดแห่งยุค สุดยอดเว็บเดิมพันมาแรงที่สุด  {" "}
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        มาพร้อมกับความเลิศล้ำ ทันสมัย โดดเด่น เป็นเอกลักษณ์ไม่เหมือนใครไม่ซ้ำใครอย่างแน่นอน และที่สำคัญที่นี่ยังได้การยอมรับว่าเป็นเว็บตรงมาตรฐานระดับสากลได้สร้างชื่อเสียงมาอ {" "}
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        ย่างยาวนาน เป็นที่รู้จักและยอมรับไปแพร่หลายอย่างวงกว้างในหมู่นักเดิมพัน คาสิโนออนไลน์ ยังไม่พอที่นี่ยังมากับระบบปฏิบัติการที่ดีที่สุด

                                                        switchbet{" "}
                                                    </p>
                                                </div>
                                                <br data-v-83acf87c="" />
                                                <div className="row pb-3" data-v-83acf87c="">
                                                    <div className="col-12" data-v-83acf87c="">
                                                        <img
                                                            className="w-100 border-article"
                                                            src="https://cdn.javisx.com/image/814e1875-8056-4c71-8c00-2fbeb3d1a07e.jpg"
                                                            alt=""
                                                            data-v-83acf87c=""
                                                        />
                                                    </div>
                                                </div>

                                                <div className="text-article text-center" data-v-83acf87c="">
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        คาสิโนออนไลน์ switchbet เว็บตรงแหล่งรวมค่าย ครบจบในที่เดียว {" "}
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        ผู้ให้บริการเกมเดิมพันออนไลน์ที่ดีที่สุดแห่งยุค สุดยอดเว็บเดิมพันมาแรงที่สุด  {" "}
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        มาพร้อมกับความเลิศล้ำ ทันสมัย โดดเด่น เป็นเอกลักษณ์ไม่เหมือนใครไม่ซ้ำใครอย่างแน่นอน และที่สำคัญที่นี่ยังได้การยอมรับว่าเป็นเว็บตรงมาตรฐานระดับสากลได้สร้างชื่อเสียงมาอ {" "}
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        ย่างยาวนาน เป็นที่รู้จักและยอมรับไปแพร่หลายอย่างวงกว้างในหมู่นักเดิมพัน คาสิโนออนไลน์ ยังไม่พอที่นี่ยังมากับระบบปฏิบัติการที่ดีที่สุด

                                                        switchbet{" "}
                                                    </p>
                                                </div>
                                                <br data-v-83acf87c="" />
                                                <div className="row pb-3" data-v-83acf87c="">
                                                    <div className="col-12" data-v-83acf87c="">
                                                        <img
                                                            className="w-100 border-article"
                                                            src="https://cdn.javisx.com/image/c299a410-d529-4a7a-a3eb-9ac8ade7c411.jpg"
                                                            alt=""
                                                            data-v-83acf87c=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="text-article mb-0 text-center" data-v-83acf87c="">
                                                    <p data-v-83acf87c="">
                                                        {" "}
                                                        <p data-v-83acf87c="">
                                                            {" "}
                                                            เว็บแทงบอล เว็บเดิมพันกีฬาออนไลน์รวมครบทุกวงจรต้องที่นี่ switchbet  {" "}
                                                        </p>
                                                        <p data-v-83acf87c="">
                                                            {" "}
                                                            ในปัจจุบันผู้คนส่วนใหญ่ในยุคสมัยนี้ให้ความสนใจในการเดิมพันกีฬาออนไลน์เป็นจำนวนมาก ทางเราจึงขอนำเสนอสุดยอดเว็บเดิมพันกีฬาออนไลน์ที่มาแรงที่สุดแห่งปี {" "}
                                                        </p>
                                                        <p data-v-83acf87c="">
                                                            {" "}
                                                            ที่นี่ได้รวบรวมการเดิมพันออนไลน์ไว้ทุกรูปแบบ ไม่ว่าจะเป็น ฟุตบอล บาสเกตบอล เบสบอล ที่นี่ก็ได้รวบรวมไว้หมดแล้วภายในเว็บของเรา   {" "}
                                                        </p>
                                                        <p data-v-83acf87c="">
                                                            {" "}
                                                            เพื่อให้ทุกท่านที่หลงรักในการเดิมพันกีฬาได้สัมผัสกับ เว็บแทงบอล ที่ดีที่สุดในเวลานี้
                                                            switchbet{" "}
                                                        </p>
                                                    </p>
                                                </div>
                                                <br data-v-83acf87c="" />
                                                <div data-v-83acf87c="">
                                                    <img
                                                        className="w-100 mt-2 mb-2 responsive-line"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/1a4467e7-1584-4c78-94f6-39d8d67d8700/public"
                                                    />
                                                </div>
                                                <div className="row pb-3 justify-content-center" data-v-83acf87c="">
                                                    <div className="col-8" data-v-83acf87c="">
                                                        <img
                                                            role="button"
                                                            src={this.state.logoimg}
                                                            className="border-home p-1 w-80 img-home-category"
                                                            alt="Home Category Image"
                                                            data-v-83acf87c=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="text-sm pb-3 text-center" data-v-83acf87c="">
                                                    <p className="mb-0" data-v-83acf87c="">
                                                        เว็บตรง switchbet เว็บลิขสิทธิ์แท้ส่งตรงจากต่างประเทศ
                                                    </p>
                                                    <p data-v-83acf87c="">
                                                        แหล่งรวมเกมคุณภาพที่ดีที่สุดแห่งปี 20024
                                                    </p>
                                                </div>
                                                <div className="text-125 pb-3 text-center" data-v-83acf87c="">
                                                    <p className="mb-0" data-v-83acf87c="">
                                                        ค่ายเกมส์
                                                    </p>
                                                </div>
                                                <div className="row pb-3" data-v-83acf87c="">
                                                    <div className="col-12" data-v-83acf87c="">
                                                        <img
                                                            className="w-100 border-article"
                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5c81820c-0cae-44ba-2b7b-012882ec9200/public"
                                                            alt=""
                                                            data-v-83acf87c=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="text-125 pb-3 text-center" data-v-83acf87c="">
                                                    <p className="mb-0" data-v-83acf87c="">
                                                        ช่องทางการชำระเงิน
                                                    </p>
                                                </div>
                                                <div className="row pb-3" data-v-83acf87c="">
                                                    <div className="col-12" data-v-83acf87c="">
                                                        <img
                                                            className="w-100 border-article"
                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2048c781-6b6f-4479-23ea-bebedd5ae500/public"
                                                            alt=""
                                                            data-v-83acf87c=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row" data-v-83acf87c="">
                                                    <div className="col-12" data-v-83acf87c="">
                                                        <div className="text-md text-center" data-v-83acf87c="">
                                                            <p data-v-83acf87c="">Copyright © 2025 All Rights Reserved.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    {/**/}

                                </div>
                                <br />
                                <br />
                            </div>
                        </div>
                    </div>
                    )}
                </div>

                <div style={{ display: tabselect == 23 ? "" : "none" }}>
                    {tabselect == 23 && (
                        <Login />
                    )}
                </div>
                <div style={{ display: tabselect == 22 ? "" : "none" }}>
                    {tabselect == 22 && (
                        <Register userrecomend={this.state.userrecomend} />
                    )}
                </div>

                <div
                    className={(this.state.showmodal) ? "modal fade show" : ""}
                    id="show_img"
                    aria-labelledby="show_imgLabel"
                    tabIndex={-1}
                    aria-modal="true"
                    role="dialog"
                    style={{ display: (this.state.showmodal) ? "block" : "none" }}
                >
                    <div className="modal-dialog modal-dialog-centered" style={{ backgroundColor: "black" }}>
                        <div className="modal-content bg-popup-modal p-2">
                            <div className="modal-header pt-0 pb-0">
                                <a
                                    href="#0"
                                    onClick={(e) =>
                                        this.setState({
                                            showmodal: false,
                                        })
                                    }
                                >
                                    <small
                                        className="text-white-v1"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={30}
                                            height={30}
                                            fill="currentColor"
                                            className="bi bi-x-circle"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </small>
                                </a>
                            </div>
                            <div className="modal-body">

                                {(prodetail.length === 0) ?
                                    <div>
                                        <img
                                            style={{ display: (prodetail.linkpicture !== null) ? "" : "none" }}
                                            src={picnonpro}
                                            alt="img_show_popup"
                                            className="img_show_popup"
                                        />
                                        <div className="box-content-pro mt-2 pt-2 pb-2">
                                            <div className="sub-content-pr0 p-2">ข้อตกลงเเละเงื่อนไข</div>
                                        </div>
                                        <div className="text-left"> <pre
                                            className="text-color-promotion"
                                            style={{ whiteSpace: "pre-line" }}
                                        >โปรโมชั่นยังไม่ได้เปิดใช้งาน
                                        </pre>
                                        </div> </div> : <div>
                                        <img

                                            style={{ display: (prodetail.linkpicture !== null) ? "" : "none" }}
                                            src={prodetail.linkpicture}
                                            alt="img_show_popup"
                                            className="w-100"
                                        />
                                        <div className="box-content-pro mt-2 pt-2 pb-2">
                                            <div className="sub-content-pr0 p-2">ข้อตกลงเเละเงื่อนไข</div>
                                        </div>
                                        <div className="text-left" style={{ color: "white" }}>
                                            <section
                                                dangerouslySetInnerHTML={{ __html: prodetail.detail }}
                                            />
                                        </div>
                                        <div className="card-footer" style={{ display: (prodetail.prolist == 5) ? "none" : "" }}>
                                            <button
                                                className="btn "
                                                style={{ fontWeight: "300", background: "radial-gradient(100% 100% at 50% 0, #f9cf95 0, #c69a5d 100%)", display: (username !== null) ? "" : "none" }}
                                                onClick={(e) => this.redeempro(e, prodetail.no)}
                                            >
                                                <span>รับโปรโมชั่น</span>
                                            </button>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footerMobileFixed" data-v-07bcaf05="">
                    <div className="container" style={{ display: loginstate ? "none" : "" }} data-v-07bcaf05="">
                        <div className="row" data-v-07bcaf05="">
                            <div className="col-md-6 offset-md-3 p-0" data-v-07bcaf05="">
                                <div
                                    className="d-flex justify-content-between pt-2 pb-2"
                                    data-v-07bcaf05=""
                                >
                                    <div className="w-100 m-1" data-v-07bcaf05="">
                                        <a
                                            role="button"
                                            href="/register"
                                            className="btn -submit js-submit-accept-term rounded-pill mt-lg-1 mt-0 w-100 p-2 border"
                                            data-v-07bcaf05=""
                                            style={{
                                                fontSize: 18,
                                                backgroundColor: "white",
                                                color: "rgb(168, 0, 0)"
                                            }}
                                        >
                                            สมัครสมาชิก
                                        </a>
                                    </div>
                                    <div className="w-100 m-1" data-v-07bcaf05="">
                                        <a
                                            role="button"
                                            className="btn -submit js-submit-accept-term rounded-pill mt-lg-1 mt-0 w-100 p-2 border"
                                            data-v-07bcaf05=""
                                            href={this.state.linelink}
                                            style={{
                                                fontSize: 18,
                                                backgroundColor: "rgb(29, 198, 34)",
                                                color: "white"
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                fill="currentColor"
                                                className="bi bi-line"
                                                viewBox="0 0 16 16"
                                                data-v-07bcaf05=""
                                            >
                                                <path
                                                    d="M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0ZM5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.154.154 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157Zm.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156h-.562Zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832a.17.17 0 0 0-.013-.015v-.001a.139.139 0 0 0-.01-.01l-.003-.003a.092.092 0 0 0-.011-.009h-.001L7.88 4.79l-.003-.002a.029.029 0 0 0-.005-.003l-.008-.005h-.002l-.003-.002-.01-.004-.004-.002a.093.093 0 0 0-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.154.154 0 0 0 .039.038l.001.001.01.006.004.002a.066.066 0 0 0 .008.004l.007.003.005.002a.168.168 0 0 0 .01.003h.003a.155.155 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156h-.561Zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.155.155 0 0 0-.108.044h-.001l-.001.002-.002.003a.155.155 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.155.155 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z"
                                                    data-v-07bcaf05=""
                                                />
                                            </svg>{" "}
                                            ติดต่อ
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container" style={{ display: loginstate ? "" : "none" }} data-v-07bcaf05="">
                        <div className="row" data-v-07bcaf05="">
                            <div
                                className="col-sm-11 col-md-8 col-lg-6 offset-lg-3 col-md-6 offset-md-2 p-0"
                                data-v-07bcaf05=""
                            >
                                <div
                                    className="x-button-actions"
                                    id="account-actions-mobile"
                                    data-v-07bcaf05=""
                                >
                                    <div className="-outer-wrapper" data-v-07bcaf05="">
                                        <div className="-right-wrapper" data-v-07bcaf05="">
                                            <a
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    this.checkurl(e, '/deposit')
                                                    //  window.location.href = '/'
                                                }}
                                                className="-item-wrapper -line"
                                                rel="noopener noreferrer"
                                                data-v-07bcaf05=""
                                            >
                                                <picture data-v-07bcaf05="">
                                                    <source
                                                        type="image/webp"
                                                        srcSet=" https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/54143b17-5da7-4394-47c6-fdceea8ca700/public"
                                                        data-v-07bcaf05=""
                                                    />
                                                    <source
                                                        type="image/png"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/54143b17-5da7-4394-47c6-fdceea8ca700/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <img
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/54143b17-5da7-4394-47c6-fdceea8ca700/public"
                                                        className="-ic-img"
                                                        width={43}
                                                        height={43}
                                                        data-v-07bcaf05=""
                                                    />
                                                </picture>
                                                <span className="-text" data-v-07bcaf05="">
                                                    ฝากเงิน
                                                </span>
                                            </a>
                                            <a
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    this.checkurl(e, '/withdraw')
                                                    //  window.location.href = '/'
                                                }}
                                                className="-item-wrapper -affiliate"
                                                data-v-d4649762=""
                                                data-v-07bcaf05=""
                                            >
                                                <picture data-v-d4649762="" data-v-07bcaf05="">
                                                    <source
                                                        type="image/webp"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8fa7cd1c-47b1-4247-d9c7-4ff33c8c1900/public
                "
                                                        data-v-d4649762=""
                                                        data-v-07bcaf05=""
                                                    />
                                                    <source
                                                        type="image/png"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8fa7cd1c-47b1-4247-d9c7-4ff33c8c1900/public
                "
                                                        data-v-d4649762=""
                                                        data-v-07bcaf05=""
                                                    />
                                                    <img
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8fa7cd1c-47b1-4247-d9c7-4ff33c8c1900/public"
                                                        className="-ic-img"
                                                        width={43}
                                                        height={43}
                                                        data-v-d4649762=""
                                                        data-v-07bcaf05=""
                                                    />
                                                </picture>
                                                <span className="-text" data-v-d4649762="" data-v-07bcaf05="">
                                                    ถอนเงิน
                                                </span>
                                            </a>
                                            <a
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    this.checkurl(e, '/')
                                                    //  window.location.href = '/'
                                                }}
                                                className="-item-wrapper -line"
                                                rel="noopener noreferrer"
                                                data-v-07bcaf05=""
                                            >
                                                <picture data-v-07bcaf05="">
                                                    <source
                                                        type="image/webp"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/50360dd2-e4eb-44ef-8bbe-bdc026328500/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <source
                                                        type="image/png"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/50360dd2-e4eb-44ef-8bbe-bdc026328500/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <img
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/50360dd2-e4eb-44ef-8bbe-bdc026328500/public"
                                                        className="-ic-img"
                                                        width={43}
                                                        height={43}
                                                        data-v-07bcaf05=""
                                                    />
                                                </picture>
                                                <span className="-text" data-v-07bcaf05="">
                                                    หน้าเเรก
                                                </span>
                                            </a>
                                            <a
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                    this.checkurl(e, '/event')
                                                    //  window.location.href = '/'
                                                }}
                                                className="-item-wrapper -line"
                                                rel="noopener noreferrer"
                                                data-v-07bcaf05=""
                                            >
                                                <picture data-v-07bcaf05="">
                                                    <source
                                                        type="image/webp"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/38f46918-da9b-457e-a2bc-6b0a23823300/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <source
                                                        type="image/png"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/38f46918-da9b-457e-a2bc-6b0a23823300/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <img
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/38f46918-da9b-457e-a2bc-6b0a23823300/public"
                                                        className="-ic-img"
                                                        width={43}
                                                        height={43}
                                                        data-v-07bcaf05=""
                                                    />
                                                </picture>
                                                <span className="-text" data-v-07bcaf05="">
                                                    กิจกรรม
                                                </span>
                                            </a>
                                            <a
                                                style={{ cursor: "pointer" }}
                                                href={this.state.linelink}
                                                className="-item-wrapper -line"
                                                rel="noopener noreferrer"
                                                data-v-07bcaf05=""
                                            >
                                                {/**/}
                                                {/**/}
                                                <picture data-v-07bcaf05="">
                                                    <source
                                                        type="image/webp"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19ef9125-647f-43a9-e22e-313e837ee600/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <source
                                                        type="image/png"
                                                        srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19ef9125-647f-43a9-e22e-313e837ee600/public
                "
                                                        data-v-07bcaf05=""
                                                    />
                                                    <img
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/19ef9125-647f-43a9-e22e-313e837ee600/public"
                                                        className="-ic-img"
                                                        width={43}
                                                        height={43}
                                                        data-v-07bcaf05=""
                                                    />
                                                </picture>
                                                <span className="-text" data-v-07bcaf05="">
                                                    Line
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {tabselect === 1 && <PopupDep />}
            </>
        );
    }
}

export default Main;
